import { Locale } from 'chaika-enums';
export const components = {
    findAndSelectFromList: {
        [Locale.Ru]: 'Найдите и выберите из списка',
        [Locale.Am]: 'Գտեք և ընտրեք ցանկից',
        [Locale.En]: 'Find and select from the list',
        [Locale.Pt]: 'Encontre e selecione na lista',
        [Locale.Ge]: 'Find and select from the list',
    },
    deletingFile: {
        [Locale.Ru]: 'Удаление файла',
        [Locale.Am]: 'Ֆայլի ջնջում',
        [Locale.En]: 'Deleting a file',
        [Locale.Pt]: 'Excluindo um arquivo',
        [Locale.Ge]: 'Deleting a file',
    },
    sureToDeleteFile: {
        [Locale.Ru]: 'Вы действительно хотите удалить файл',
        [Locale.Am]: 'Իսկապե՞ս ուզում եք ջնջել ֆայլը',
        [Locale.En]: 'Are you sure you want to delete the file',
        [Locale.Pt]: 'Tem certeza de que deseja excluir o arquivo',
        [Locale.Ge]: 'Are you sure you want to delete the file',
    },
    incorrectFileType: {
        [Locale.Ru]: 'Некорректные типы файлов. Поддерживаемые типы',
        [Locale.Am]: 'Ֆայլերի սխալ տեսակներ։ Աջակցվող տեսակներ',
        [Locale.En]: 'Incorrect file types. Supported types',
        [Locale.Pt]: 'Tipos de arquivo incorretos. Tipos suportados',
        [Locale.Ge]: 'Incorrect file types. Supported types',
    },
    errorOnFileDownloading: {
        [Locale.Ru]: 'При загрузке файла возникла ошибка',
        [Locale.Am]: 'Ֆայլը վերբեռնելիս առաջացել է սխալ',
        [Locale.En]: 'An error occurred while downloading the file',
        [Locale.Pt]: 'Ocorreu um erro ao baixar o arquivo',
        [Locale.Ge]: 'An error occurred while downloading the file',
    },
    invalidFileNumbers: {
        [Locale.Ru]: 'Недопустимое количество файлов. Можно загрузить только один файл.',
        [Locale.Am]: 'Ֆայլերի անթույլատրելի քանակ։ Կարելի է վերբեռնել միայն մեկ ֆայլ։',
        [Locale.En]: 'Invalid number of files. You can only upload one file.',
        [Locale.Pt]: 'Número inválido de arquivos. Você pode carregar apenas um arquivo.',
        [Locale.Ge]: 'Invalid number of files. You can only upload one file.',
    },
    errorOnFileDeleting: {
        [Locale.Ru]: 'При удалении файла возникла ошибка',
        [Locale.Am]: 'Ֆայլը ջնջելիս առաջացել է սխալ',
        [Locale.En]: 'An error occurred while deleting the file',
        [Locale.Pt]: 'Ocorreu um erro ao excluir o arquivo',
        [Locale.Ge]: 'An error occurred while deleting the file',
    },
    listOfFiles: {
        [Locale.Ru]: 'Список файлов',
        [Locale.Am]: 'Ֆայլերի ցանկ',
        [Locale.En]: 'List of files',
        [Locale.Pt]: 'Lista de arquivos',
        [Locale.Ge]: 'List of files',
    },
    createNewPatient: {
        [Locale.Ru]: 'Создать нового пациента',
        [Locale.Am]: 'Ստեղծել նոր պացիենտ',
        [Locale.En]: 'Create new patient',
        [Locale.Pt]: 'Criar novo paciente',
        [Locale.Ge]: 'Create new patient',
    },
    toCancel: {
        [Locale.Ru]: 'К отмене',
        [Locale.Am]: 'Չեղարկման ենթակա',
        [Locale.En]: 'To cancel',
        [Locale.Pt]: 'Para cancelar',
        [Locale.Ge]: 'To cancel',
    },
    toPay: {
        [Locale.Ru]: 'К оплате',
        [Locale.Am]: 'Վճարման ենթակա',
        [Locale.En]: 'To pay',
        [Locale.Pt]: 'A pagar',
        [Locale.Ge]: 'გადასახდელი',
    },
    deleteSubGroupQ: {
        [Locale.Ru]: 'Удалить подгруппу и её содержимое?',
        [Locale.Am]: 'Ջնջե՞լ ենթախումբը և դրա պարունակությունը',
        [Locale.En]: 'Delete a subgroup and its contents?',
        [Locale.Pt]: 'Excluir um subgrupo e seu conteúdo?',
        [Locale.Ge]: 'Delete a subgroup and its contents?',
    },
    deleteGroupQ: {
        [Locale.Ru]: 'Удалить группу и её содержимое?',
        [Locale.Am]: 'Ջնջե՞լ խումբը և դրա պարունակությունը',
        [Locale.En]: 'Delete a group and its contents?',
        [Locale.Pt]: 'Excluir um grupo e seu conteúdo?',
        [Locale.Ge]: 'Delete a group and its contents?',
    },
    groupForField: {
        [Locale.Ru]: 'Группа для поля',
        [Locale.Am]: 'Խումբ դաշտի համար',
        [Locale.En]: 'Group for field',
        [Locale.Pt]: 'Grupo de Campo',
        [Locale.Ge]: 'Group for field',
    },
    saveNestedTemplates: {
        [Locale.Ru]: 'Сохранить вложенные шаблоны',
        [Locale.Am]: 'Պահպանել ներդրված ձևանմուշները',
        [Locale.En]: 'Save nested templates',
        [Locale.Pt]: 'Salvar modelos aninhados',
        [Locale.Ge]: 'Save nested templates',
    },
    removeReferralFromGroup: {
        [Locale.Ru]: 'Удаление направления из группы',
        [Locale.Am]: 'Ուղեգրի հեռացում խմբից',
        [Locale.En]: 'Removing a referral from a group',
        [Locale.Pt]: 'Removendo uma indicação de um grupo',
        [Locale.Ge]: 'Removing a referral from a group',
    },
    changesSaved: {
        [Locale.Ru]: 'Изменения сохранены',
        [Locale.Am]: 'Փոփոխությունները պահպանված են',
        [Locale.En]: 'Changes saved',
        [Locale.Pt]: 'Alterações salvas',
        [Locale.Ge]: 'Changes saved',
    },
    emptySchedule: {
        [Locale.Ru]: `Нет расписаний, удовлетворяющих заданным условиям.
Измените параметры фильтрации или просмотрите все доступные модели при помощи кнопки «Показать
неработающих»`,
        [Locale.Am]: `Չկան նշված պայմաններին համապատասխանող ժամանակացույցեր։
Փոփոխեք զտման պարամետրերը կամ դիտեք բոլոր հասանելի մոդելները «Ցուցադրել
չաշխատողներին» կոճակի միջոցով`,
        [Locale.En]: `There are no schedules that meet the specified conditions.
Change filtering options or view all available models using the Show button
unemployed"`,
        [Locale.Pt]: `Não existem horários que reúnam as condições especificadas.
Altere as opções de filtragem ou visualize todos os modelos disponíveis utilizando o botão Mostrar.
desempregado"`,
        [Locale.Ge]: `There are no schedules that meet the specified conditions.
Change filtering options or view all available models using the Show button
unemployed"`,
    },
    reserveOnOutOfDate: {
        [Locale.Ru]: 'Вы записываете пациента на нерабочее время. Все равно записать?',
        [Locale.Am]: 'Դուք գրանցում եք պացիենտին ոչ աշխատանքային ժամի։ Այնուամենայնի՞վ գրանցել',
        [Locale.En]: 'You make an appointment for a patient after hours. Record it anyway?',
        [Locale.Pt]: 'Você marca uma consulta para um paciente depois do expediente. Gravar mesmo assim?',
        [Locale.Ge]: 'You make an appointment for a patient after hours. Record it anyway?',
    },
    resolveConflict: {
        [Locale.Ru]: 'Решить конфликт',
        [Locale.Am]: 'Լուծել կոնֆլիկտը',
        [Locale.En]: 'Resolve conflict',
        [Locale.Pt]: 'Resolver conflito',
        [Locale.Ge]: 'Resolve conflict',
    },
    planner: {
        [Locale.Ru]: 'Планировщик',
        [Locale.Am]: 'Պլանավորիչ',
        [Locale.En]: 'Planner',
        [Locale.Pt]: 'Planejador',
        [Locale.Ge]: 'Planner',
    },
    defaultSubscriptionPrices: {
        [Locale.Ru]: 'Цены на подписку по умолчанию',
        [Locale.Am]: 'Բաժանորդագրության լռելյայն գներ',
        [Locale.En]: 'Default subscription prices',
        [Locale.Pt]: 'Preços de assinatura padrão',
        [Locale.Ge]: 'Default subscription prices',
    },
    defaultPriceApplied: {
        [Locale.Ru]: 'Применяется цена по умолчанию',
        [Locale.Am]: 'Կիրառվում է լռելյայն գինը',
        [Locale.En]: 'Default price applied',
        [Locale.Pt]: 'Preço padrão aplicado',
        [Locale.Ge]: 'Default price applied',
    },
    solutions: {
        [Locale.Ru]: 'Варинты решения',
        [Locale.Am]: 'Լուծման տարբերակներ',
        [Locale.En]: 'Solution options',
        [Locale.Pt]: 'Opções de solução',
        [Locale.Ge]: 'Solution options',
    },
    hasAssistant: {
        [Locale.Ru]: 'есть ассистент',
        [Locale.Am]: 'կա օգնական',
        [Locale.En]: 'has assistant',
        [Locale.Pt]: 'tem assistente',
        [Locale.Ge]: 'has assistant',
    },
    resetFilters: {
        [Locale.Ru]: 'Сбросить фильтры',
        [Locale.Am]: 'Զրոյացնել զտիչները',
        [Locale.En]: 'Reset filters',
        [Locale.Pt]: 'Redefinir filtros',
        [Locale.Ge]: 'Reset filters',
    },
    clearFilter: {
        [Locale.Ru]: 'Очистить фильтр',
        [Locale.Am]: 'Մաքրել զտիչը',
        [Locale.En]: 'Clear filter',
        [Locale.Pt]: 'Limpar filtro',
        [Locale.Ge]: 'Clear filter',
    },
    doFilter: {
        [Locale.Ru]: 'Отфильтровать',
        [Locale.Am]: 'Զտել',
        [Locale.En]: 'Filter',
        [Locale.Pt]: 'Filtro',
        [Locale.Ge]: 'Filter',
    },
    byEndDate: {
        [Locale.Ru]: 'По дате окончания',
        [Locale.Am]: 'Ըստ ավարտի ամսաթվի',
        [Locale.En]: 'By end date',
        [Locale.Pt]: 'Por data de mandato',
        [Locale.Ge]: 'By end date',
    },
    accessDenied: {
        [Locale.Ru]: 'Отказано в доступе',
        [Locale.Am]: 'Մուտքն արգելված է',
        [Locale.En]: 'Access denied',
        [Locale.Pt]: 'Acesso negado',
        [Locale.Ge]: 'Access denied',
    },
    ehrAccessBlacklisted: {
        [Locale.Ru]: 'Пациент заблокировал для вас доступ к своим медицинским данным.\nЧтобы получить доступ, пациент должен самостоятельно разблокировать вас в своём личном кабинете',
        [Locale.Am]: 'Պացիենտն արգելափակել է ձեր մուտքը իր բժշկական տվյալներին։\nՄուտք ստանալու համար պացիենտը պետք է ինքնուրույն ապաարգելափակի ձեզ իր անձնական հաշվում',
        [Locale.En]: 'The patient has blocked your access to their medical data.\nTo get access, the patient must unblock you themselves in their personal account',
        [Locale.Pt]: 'O paciente bloqueou o seu acesso aos seus dados médicos.\nPara obter acesso, o paciente deve desbloqueá-lo por conta própria na sua área pessoal',
        [Locale.Ge]: 'The patient has blocked your access to their medical data.\nTo get access, the patient must unblock you themselves in their personal account',
    },
    ehrAccessNoGrant: {
        [Locale.Ru]: 'Вы не участвуете в лечении пациента, поэтому доступ к данным пациента ограничен.\nВ личном кабинете пациент видит информацию о сотрудниках, которые имеют доступ к медицинским данным',
        [Locale.Am]: 'Դուք չեք մասնակցում պացիենտի բուժմանը, ուստի պացիենտի տվյալների հասանելիությունը սահմանափակ է։\nԱնձնական հաշվում պացիենտը տեսնում է տեղեկություն այն աշխատակիցների մասին, ովքեր հասանելիություն ունեն բժշկական տվյալներին',
        [Locale.En]: 'You are not involved in the patient\'s treatment, so access to the patient\'s data is restricted.\nIn their personal account, the patient can see the staff members who have access to their medical data',
        [Locale.Pt]: 'Você não participa do tratamento do paciente, portanto o acesso aos dados do paciente está restrito.\nNa área pessoal, o paciente vê os funcionários que têm acesso aos seus dados médicos',
        [Locale.Ge]: 'You are not involved in the patient\'s treatment, so access to the patient\'s data is restricted.\nIn their personal account, the patient can see the staff members who have access to their medical data',
    },
    ehrAccessBlacklistedTitle: {
        [Locale.Ru]: 'Доступ к медицинским данным заблокирован',
        [Locale.Am]: 'Բժշկական տվյալների հասանելիությունն արգելափակված է',
        [Locale.En]: 'Access to medical data is blocked',
        [Locale.Pt]: 'O acesso aos dados médicos está bloqueado',
        [Locale.Ge]: 'Access to medical data is blocked',
    },
    ehrAccessNoGrantTitle: {
        [Locale.Ru]: 'Медицинские данные недоступны',
        [Locale.Am]: 'Բժշկական տվյալներն անհասանելի են',
        [Locale.En]: 'Medical data is unavailable',
        [Locale.Pt]: 'Dados médicos indisponíveis',
        [Locale.Ge]: 'Medical data is unavailable',
    },
    createEntryInEhr: {
        [Locale.Ru]: 'Создать запись в карте',
        [Locale.Am]: 'Ստեղծել գրառում քարտում',
        [Locale.En]: 'Create a record',
        [Locale.Pt]: 'Criar um registro',
        [Locale.Ge]: 'Create a record',
    },
    bookingAccessNoticeTitle: {
        [Locale.Ru]: 'Доктор $doctor и его команда',
        [Locale.Am]: '$doctor բժիշկը և նրա թիմը',
        [Locale.En]: 'Doctor $doctor and the team',
        [Locale.Pt]: 'O médico $doctor e a equipa',
        [Locale.Ge]: 'Doctor $doctor and the team',
    },
    bookingAccessNoticeAccessTerm: {
        [Locale.Ru]: 'Получат доступ к карте на 30 дней',
        [Locale.Am]: 'Կստանան քարտի հասանելիություն 30 օրով',
        [Locale.En]: 'Will get access to the chart for 30 days',
        [Locale.Pt]: 'Terão acesso ao prontuário por 30 dias',
        [Locale.Ge]: 'Will get access to the chart for 30 days',
    },
    bookingBlacklistNotice: {
        [Locale.Ru]: 'Пациент добавил доктора $doctor в чёрный список.',
        [Locale.Am]: 'Պացիենտն ավելացրել է $doctor բժշկին սև ցուցակում։',
        [Locale.En]: 'The patient added doctor $doctor to the blacklist.',
        [Locale.Pt]: 'O paciente adicionou o médico $doctor à lista negra.',
        [Locale.Ge]: 'The patient added doctor $doctor to the blacklist.',
    },
    ok: {
        [Locale.Ru]: 'Ок',
        [Locale.Am]: 'Լավ',
        [Locale.En]: 'Ok',
        [Locale.Pt]: 'OK',
        [Locale.Ge]: 'Ok',
    },
    sessionMayExpired: {
        [Locale.Ru]: 'Возможно ваша сессия истекла',
        [Locale.Am]: 'Հնարավոր է՝ ձեր սեսիայի ժամկետը լրացել է',
        [Locale.En]: 'Your session may have expired',
        [Locale.Pt]: 'Sua sessão pode ter expirado',
        [Locale.Ge]: 'Your session may have expired',
    },
    login: {
        [Locale.Ru]: 'Авторизоваться',
        [Locale.Am]: 'Մուտք գործել',
        [Locale.En]: 'Login',
        [Locale.Pt]: 'Entrar',
        [Locale.Ge]: 'Login',
    },
    toMainPage: {
        [Locale.Ru]: 'Перейти на главную',
        [Locale.Am]: 'Անցնել գլխավոր էջ',
        [Locale.En]: 'Go to Main page',
        [Locale.Pt]: 'Ir para a página principal',
        [Locale.Ge]: 'Go to Main page',
    },
    needLogIn: {
        [Locale.Ru]: 'Необходимо авторизоваться',
        [Locale.Am]: 'Անհրաժեշտ է մուտք գործել',
        [Locale.En]: 'You must log in',
        [Locale.Pt]: 'Você deve fazer login',
        [Locale.Ge]: 'You must log in',
    },
    noClinicsAvailable: {
        [Locale.Ru]: 'Нет доступных клиник',
        [Locale.Am]: 'Հասանելի կլինիկաներ չկան',
        [Locale.En]: 'No clinics available',
        [Locale.Pt]: 'Não há clínicas disponíveis',
        [Locale.Ge]: 'No clinics available',
    },
    selectOrganization: {
        [Locale.Ru]: 'Выбрать организацию',
        [Locale.Am]: 'Ընտրել կազմակերպություն',
        [Locale.En]: 'Select organization',
        [Locale.Pt]: 'Selecione a organização',
        [Locale.Ge]: 'Select organization',
    },
    selectOrganizationYou: {
        [Locale.Ru]: `Выберите организацию`,
        [Locale.Am]: `Ընտրեք կազմակերպությունը`,
        [Locale.En]: `Select an organization`,
        [Locale.Pt]: 'Selecione uma organização',
        [Locale.Ge]: `Select an organization`,
    },
    selectOrganizationToReceive: {
        [Locale.Ru]: 'Выберите клинику, в которой вы принимаете',
        [Locale.Am]: 'Ընտրեք կլինիկան, որտեղ դուք ընդունում եք',
        [Locale.En]: 'Select the clinic where you receive',
        [Locale.Pt]: 'Selecione a clínica onde você recebe',
        [Locale.Ge]: 'Select the clinic where you receive',
    },
    cantLinkUserWithoutOrganization: {
        [Locale.Ru]: 'Нельзя привязать пользователя без организации',
        [Locale.Am]: 'Չի կարելի կցել օգտատիրոջն առանց կազմակերպության',
        [Locale.En]: 'You cannot link a user without an organization',
        [Locale.Pt]: 'Você não pode vincular um usuário sem uma organização',
        [Locale.Ge]: 'You cannot link a user without an organization',
    },
    hasOrganizationWithoutStoreId: {
        [Locale.Ru]: 'Есть организации в которых отсутствует store Id',
        [Locale.Am]: 'Կան կազմակերպություններ, որոնցում բացակայում է store Id-ն',
        [Locale.En]: 'There are organizations that do not have store Id',
        [Locale.Pt]: 'Existem organizações que não possuem ID de loja',
        [Locale.Ge]: 'There are organizations that do not have store Id',
    },
    dataByOrganization: {
        [Locale.Ru]: 'Данные по организациям',
        [Locale.Am]: 'Տվյալներ ըստ կազմակերպությունների',
        [Locale.En]: 'Data by organization',
        [Locale.Pt]: 'Dados por organização',
        [Locale.Ge]: 'Data by organization',
    },
    processingStartDate: {
        [Locale.Ru]: 'Дата начала обработки',
        [Locale.Am]: 'Մշակման սկզբի ամսաթիվ',
        [Locale.En]: 'Processing start date',
        [Locale.Pt]: 'Data de início do processamento',
        [Locale.Ge]: 'Processing start date',
    },
    processingEndDate: {
        [Locale.Ru]: 'Дата окончания обработки',
        [Locale.Am]: 'Մշակման ավարտի ամսաթիվ',
        [Locale.En]: 'Processing end date',
        [Locale.Pt]: 'Data de término do processamento',
        [Locale.Ge]: 'Processing end date',
    },
    fileProcessingStatus: {
        [Locale.Ru]: 'Статус обработки файлов',
        [Locale.Am]: 'Ֆայլերի մշակման կարգավիճակ',
        [Locale.En]: 'File processing status',
        [Locale.Pt]: 'Status de processamento de arquivo',
        [Locale.Ge]: 'File processing status',
    },
    attacmentProcessingStatus: {
        [Locale.Ru]: 'Статус обработки файлов',
        [Locale.Am]: 'Ֆայլերի մշակման կարգավիճակ',
        [Locale.En]: 'Attacment processing status',
        [Locale.Pt]: 'Status de processamento de anexos',
        [Locale.Ge]: 'Attacment processing status',
    },
    attachmentDublication: {
        [Locale.Ru]: 'Дубли откреплений/прикреплений',
        [Locale.Am]: 'Կցումների/անջատումների կրկնօրինակներ',
        [Locale.En]: 'Duplicate checkouts/attachments',
        [Locale.Pt]: 'Checkouts/anexos duplicados',
        [Locale.Ge]: 'Duplicate checkouts/attachments',
    },
    findPatient: {
        [Locale.Ru]: 'Поиск карты пациента',
        [Locale.Am]: 'Պացիենտի քարտի որոնում',
        [Locale.En]: 'Finding a Patient Card',
        [Locale.Pt]: 'Encontrar um cartão de paciente',
        [Locale.Ge]: 'Finding a Patient Card',
    },
    misSummoryReport: {
        [Locale.Ru]: 'Сводный отчёт МИС',
        [Locale.Am]: 'ԲՏՀ ամփոփ հաշվետվություն',
        [Locale.En]: 'MIS summary report',
        [Locale.Pt]: 'Relatório resumido do MIS',
        [Locale.Ge]: 'MIS summary report',
    },
    xReport: {
        [Locale.Ru]: 'X-отчёт',
        [Locale.Am]: 'X-հաշվետվություն',
        [Locale.En]: 'X-report',
        [Locale.Pt]: 'Relatório X',
        [Locale.Ge]: 'X-report',
    },
    zReport: {
        [Locale.Ru]: 'Z-отчеты по закрытым сменам',
        [Locale.Am]: 'Z-հաշվետվություններ փակված հերթափոխերի վերաբերյալ',
        [Locale.En]: 'Z-reports for closed shifts',
        [Locale.Pt]: 'Relatórios Z para turnos fechados',
        [Locale.Ge]: 'Z-reports for closed shifts',
    },
    misSummoryReportOnClosed: {
        [Locale.Ru]: 'Сводные отчёты МИС по закрытым сменам',
        [Locale.Am]: 'ԲՏՀ ամփոփ հաշվետվություններ փակված հերթափոխերի վերաբերյալ',
        [Locale.En]: 'MIS summary reports for closed shifts',
        [Locale.Pt]: 'Relatórios resumidos do MIS para turnos fechados',
        [Locale.Ge]: 'MIS summary reports for closed shifts',
    },
    closeShift: {
        [Locale.Ru]: 'Закрыть смену',
        [Locale.Am]: 'Փակել հերթափոխը',
        [Locale.En]: 'Close shift',
        [Locale.Pt]: 'Fechar turno',
        [Locale.Ge]: 'Close shift',
    },
    printXReport: {
        [Locale.Ru]: 'Распечатать Х-отчёт',
        [Locale.Am]: 'Տպել X-հաշվետվությունը',
        [Locale.En]: 'Print X-report',
        [Locale.Pt]: 'Imprimir relatório X',
        [Locale.Ge]: 'Print X-report',
    },
    reportByPaymentMethods: {
        [Locale.Ru]: 'Сводный отчет по методам оплат',
        [Locale.Am]: 'Ամփոփ հաշվետվություն ըստ վճարման եղանակների',
        [Locale.En]: 'Summary report on payment methods',
        [Locale.Pt]: 'Relatório resumido sobre métodos de pagamento',
        [Locale.Ge]: 'Summary report on payment methods',
    },
    closingShift: {
        [Locale.Ru]: 'Закрытие смены',
        [Locale.Am]: 'Հերթափոխի փակում',
        [Locale.En]: 'Closing a shift',
        [Locale.Pt]: 'Fechando um turno',
        [Locale.Ge]: 'Closing a shift',
    },
    doYouWantCloseShift: {
        [Locale.Ru]: 'Вы действительно хотите закрыть смену?',
        [Locale.Am]: 'Իսկապե՞ս ուզում եք փակել հերթափոխը',
        [Locale.En]: 'Do you really want to close your shift?',
        [Locale.Pt]: 'Você realmente quer encerrar seu turno?',
        [Locale.Ge]: 'Do you really want to close your shift?',
    },
    failOnCloseShift: {
        [Locale.Ru]: 'Не удалось закрыть смену',
        [Locale.Am]: 'Չհաջողվեց փակել հերթափոխը',
        [Locale.En]: 'Failed to close shift',
        [Locale.Pt]: 'Falha ao fechar turno',
        [Locale.Ge]: 'Failed to close shift',
    },
    failOnPrintXReport: {
        [Locale.Ru]: 'Не удалось распечатать Х-отчёт',
        [Locale.Am]: 'Չհաջողվեց տպել X-հաշվետվությունը',
        [Locale.En]: 'Failed to print X-report',
        [Locale.Pt]: 'Falha ao imprimir o relatório X',
        [Locale.Ge]: 'Failed to print X-report',
    },
    advancePayment: {
        [Locale.Ru]: 'Предварительная оплата (Аванс)',
        [Locale.Am]: 'Կանխավճար',
        [Locale.En]: 'Advance payment',
        [Locale.Pt]: 'Pagamento antecipado',
        [Locale.Ge]: 'Advance payment',
    },
    changeableResults: {
        [Locale.Ru]: 'Сменные итоги',
        [Locale.Am]: 'Հերթափոխի արդյունքներ',
        [Locale.En]: 'Changeable results',
        [Locale.Pt]: 'Resultados mutáveis',
        [Locale.Ge]: 'Changeable results',
    },
    renderedServiceCreationDate: {
        [Locale.Ru]: 'Дата создания оказанной услуги',
        [Locale.Am]: 'Մատուցված ծառայության ստեղծման ամսաթիվ',
        [Locale.En]: 'Date of creation of the rendered service',
        [Locale.Pt]: 'Data de criação do serviço prestado',
        [Locale.Ge]: 'Date of creation of the rendered service',
    },
    serviceId: {
        [Locale.Ru]: 'ID услуги',
        [Locale.Am]: 'Ծառայության ID',
        [Locale.En]: 'Service ID',
        [Locale.Pt]: 'ID do serviço',
        [Locale.Ge]: 'Service ID',
    },
    RenderedServicesId: {
        [Locale.Ru]: 'ID оказанных услуг',
        [Locale.Am]: 'Մատուցված ծառայությունների ID',
        [Locale.En]: 'Rendered Services ID',
        [Locale.Pt]: 'ID dos serviços prestados',
        [Locale.Ge]: 'Rendered Services ID',
    },
    renderedServices: {
        [Locale.Ru]: 'Оказанные услуги',
        [Locale.Am]: 'Մատուցված ծառայություններ',
        [Locale.En]: 'Rendered Services',
        [Locale.Pt]: 'Serviços Prestados',
        [Locale.Ge]: 'Rendered Services',
    },
    renderedService: {
        [Locale.Ru]: 'Оказанная услуга',
        [Locale.Am]: 'Մատուցված ծառայություն',
        [Locale.En]: 'Rendered Service',
        [Locale.Pt]: 'Serviço Prestado',
        [Locale.Ge]: 'Rendered Service',
    },
    paymentFail: {
        [Locale.Ru]: 'Платёж не удался',
        [Locale.Am]: 'Վճարումը չհաջողվեց',
        [Locale.En]: 'Payment failed',
        [Locale.Pt]: 'Falha no pagamento',
        [Locale.Ge]: 'Payment failed',
    },
    shiftClosed: {
        [Locale.Ru]: 'Смена закрыта',
        [Locale.Am]: 'Հերթափոխը փակված է',
        [Locale.En]: 'Shift closed',
        [Locale.Pt]: 'Turno fechado',
        [Locale.Ge]: 'Shift closed',
    },
    userProfile: {
        [Locale.Ru]: 'Профиль пользователя',
        [Locale.Am]: 'Օգտատիրոջ պրոֆիլ',
        [Locale.En]: 'User profile',
        [Locale.Pt]: 'Perfil de usuário',
        [Locale.Ge]: 'User profile',
    },
    userOrganizations: {
        [Locale.Ru]: 'Организации пользователя',
        [Locale.Am]: 'Օգտատիրոջ կազմակերպությունները',
        [Locale.En]: 'User organizations',
        [Locale.Pt]: 'Organizações de usuários',
        [Locale.Ge]: 'User organizations',
    },
    workTime: {
        [Locale.Ru]: 'Рабочее время',
        [Locale.Am]: 'Աշխատանքային ժամեր',
        [Locale.En]: 'Work time',
        [Locale.Pt]: 'Tempo de trabalho',
        [Locale.Ge]: 'work time',
    },
    sentNotifications: {
        [Locale.Ru]: 'Отправленные уведомления',
        [Locale.Am]: 'Ուղարկված ծանուցումներ',
        [Locale.En]: 'Sent notifications',
        [Locale.Pt]: 'Notificações enviadas',
        [Locale.Ge]: 'Sent notifications',
    },
    receptionSettings: {
        [Locale.Ru]: 'Настройки приёма',
        [Locale.Am]: 'Ընդունելության կարգավորումներ',
        [Locale.En]: 'Reception settings',
        [Locale.Pt]: 'Configurações de recepção',
        [Locale.Ge]: 'Reception settings',
    },
    patientsAge: {
        [Locale.Ru]: 'Возраст пациентов',
        [Locale.Am]: 'Պացիենտների տարիք',
        [Locale.En]: 'Patients age',
        [Locale.Pt]: 'Idade dos pacientes',
        [Locale.Ge]: 'Patients age',
    },
    specialtiesPriorityHint: {
        [Locale.Ru]: 'Указывайте в порядке приоритета. От основной к второстепенным',
        [Locale.Am]: 'Նշեք առաջնահերթության կարգով՝ հիմնականից երկրորդականներին',
        [Locale.En]: 'List in priority order. From primary to secondary',
        [Locale.Pt]: 'Liste em ordem de prioridade. Da principal às secundárias',
        [Locale.Ge]: 'List in priority order. From primary to secondary',
    },
    addSpecialty: {
        [Locale.Ru]: 'Добавить специальность',
        [Locale.Am]: 'Ավելացնել մասնագիտություն',
        [Locale.En]: 'Add specialty',
        [Locale.Pt]: 'Adicionar especialidade',
        [Locale.Ge]: 'Add specialty',
    },
    commonTransaltions: {
        [Locale.Ru]: 'Общие переводы',
        [Locale.Am]: 'Ընդհանուր թարգմանություններ',
        [Locale.En]: 'Common transaltions',
        [Locale.Pt]: 'Transações comuns',
        [Locale.Ge]: 'Common transaltions',
    },
    individualPrice: {
        [Locale.Ru]: 'Индивидуальный прайс',
        [Locale.Am]: 'Անհատական գնացուցակ',
        [Locale.En]: 'Individual price',
        [Locale.Pt]: 'Preço individual',
        [Locale.Ge]: 'Individual price',
    },
    providedServices: {
        [Locale.Ru]: 'Оказываемые услуги',
        [Locale.Am]: 'Մատուցվող ծառայություններ',
        [Locale.En]: 'Provided services',
        [Locale.Pt]: 'Serviços prestados',
        [Locale.Ge]: 'Provided services',
    },
    mainServices: {
        [Locale.Ru]: 'Основные услуги',
        [Locale.Am]: 'Հիմնական ծառայություններ',
        [Locale.En]: 'Main services',
        [Locale.Pt]: 'Serviços principais',
        [Locale.Ge]: 'Main services',
    },
    otherServices: {
        [Locale.Ru]: 'Другие услуги',
        [Locale.Am]: 'Այլ ծառայություններ',
        [Locale.En]: 'Other services',
        [Locale.Pt]: 'Outros serviços',
        [Locale.Ge]: 'Other services',
    },
    addMainService: {
        [Locale.Ru]: 'Добавить основную услугу',
        [Locale.Am]: 'Ավելացնել հիմնական ծառայություն',
        [Locale.En]: 'Add main service',
        [Locale.Pt]: 'Adicionar serviço principal',
        [Locale.Ge]: 'Add main service',
    },
    servicesNotAdded: {
        [Locale.Ru]: 'Услуги не добавлены',
        [Locale.Am]: 'Ծառայություններ ավելացված չեն',
        [Locale.En]: 'No services added',
        [Locale.Pt]: 'Nenhum serviço adicionado',
        [Locale.Ge]: 'No services added',
    },
    serviceNotAdded: {
        [Locale.Ru]: 'Услуга не добавлена',
        [Locale.Am]: 'Ծառայությունը ավելացված չէ',
        [Locale.En]: 'Service not added',
        [Locale.Pt]: 'Serviço não adicionado',
        [Locale.Ge]: 'Service not added',
    },
    mainInPersonService: {
        [Locale.Ru]: 'Основная очная услуга',
        [Locale.Am]: 'Հիմնական առերես ծառայություն',
        [Locale.En]: 'Main in-person service',
        [Locale.Pt]: 'Principal serviço presencial',
        [Locale.Ge]: 'Main in-person service',
    },
    makeMainOnlineService: {
        [Locale.Ru]: 'Сделать основной онлайн',
        [Locale.Am]: 'Դարձնել հիմնական առցանց',
        [Locale.En]: 'Make main online',
        [Locale.Pt]: 'Tornar principal online',
        [Locale.Ge]: 'Make main online',
    },
    makeMainInPersonService: {
        [Locale.Ru]: 'Сделать основной очной',
        [Locale.Am]: 'Դարձնել հիմնական առերես',
        [Locale.En]: 'Make main in-person',
        [Locale.Pt]: 'Tornar principal presencial',
        [Locale.Ge]: 'Make main in-person',
    },
    editService: {
        [Locale.Ru]: 'Редактировать услугу',
        [Locale.Am]: 'Խմբագրել ծառայությունը',
        [Locale.En]: 'Edit service',
        [Locale.Pt]: 'Editar serviço',
        [Locale.Ge]: 'Edit service',
    },
    deleteServiceConfirm: {
        [Locale.Ru]: 'Удалить услугу «$serviceName»?',
        [Locale.Am]: 'Ջնջե՞լ «$serviceName» ծառայությունը։',
        [Locale.En]: 'Delete the service "$serviceName"?',
        [Locale.Pt]: 'Excluir o serviço "$serviceName"?',
        [Locale.Ge]: 'Delete the service "$serviceName"?',
    },
    replaceMainInPersonServiceConfirm: {
        [Locale.Ru]: 'Основная очная услуга уже назначена: «$serviceName». Заменить её?',
        [Locale.Am]: 'Հիմնական առերես ծառայությունն արդեն նշանակված է՝ «$serviceName»։ Փոխարինե՞լ այն։',
        [Locale.En]: 'The main in-person service is already set: "$serviceName". Replace it?',
        [Locale.Pt]: 'O principal serviço presencial já está definido: "$serviceName". Substituí-lo?',
        [Locale.Ge]: 'The main in-person service is already set: "$serviceName". Replace it?',
    },
    replaceMainOnlineServiceConfirm: {
        [Locale.Ru]: 'Основная онлайн-услуга уже назначена: «$serviceName». Заменить её?',
        [Locale.Am]: 'Հիմնական առցանց ծառայությունն արդեն նշանակված է՝ «$serviceName»։ Փոխարինե՞լ այն։',
        [Locale.En]: 'The main online service is already set: "$serviceName". Replace it?',
        [Locale.Pt]: 'O principal serviço online já está definido: "$serviceName". Substituí-lo?',
        [Locale.Ge]: 'The main online service is already set: "$serviceName". Replace it?',
    },
    removeFromMainServices: {
        [Locale.Ru]: 'Убрать из основных',
        [Locale.Am]: 'Հեռացնել հիմնականներից',
        [Locale.En]: 'Remove from main',
        [Locale.Pt]: 'Remover das principais',
        [Locale.Ge]: 'Remove from main',
    },
    changeDuration: {
        [Locale.Ru]: 'Изменить длительность',
        [Locale.Am]: 'Փոփոխել տևողությունը',
        [Locale.En]: 'Change duration',
        [Locale.Pt]: 'Alterar duração',
        [Locale.Ge]: 'Change duration',
    },
    inPersonConsultation: {
        [Locale.Ru]: 'Очная консультация',
        [Locale.Am]: 'Առերես խորհրդատվություն',
        [Locale.En]: 'In-person consultation',
        [Locale.Pt]: 'Consulta presencial',
        [Locale.Ge]: 'In-person consultation',
    },
    notificationSettings: {
        [Locale.Ru]: 'Настройки уведомлений',
        [Locale.Am]: 'Ծանուցումների կարգավորումներ',
        [Locale.En]: 'Notification settings',
        [Locale.Pt]: 'Configurações de notificação',
        [Locale.Ge]: 'Notification settings',
    },
    takingBiomaterial: {
        [Locale.Ru]: 'Взятие биоматериала',
        [Locale.Am]: 'Կենսանյութի վերցնում',
        [Locale.En]: 'Taking biomaterial',
        [Locale.Pt]: 'Tomando biomaterial',
        [Locale.Ge]: 'Taking biomaterial',
    },
    queueForDescription: {
        [Locale.Ru]: 'Очередь на описание',
        [Locale.Am]: 'Հերթ նկարագրության համար',
        [Locale.En]: 'Queue for description',
        [Locale.Pt]: 'Fila para descrição',
        [Locale.Ge]: 'Queue for description',
    },
    byVaccination: {
        [Locale.Ru]: 'По вакцинации',
        [Locale.Am]: 'Ըստ պատվաստումների',
        [Locale.En]: 'By vaccination',
        [Locale.Pt]: 'Por vacinação',
        [Locale.Ge]: 'By vaccination',
    },
    invitroArmenia: {
        [Locale.Ru]: 'Инвитро Армения',
        [Locale.Am]: 'Ինվիտրո Հայաստան',
        [Locale.En]: 'Invitro Armenia',
        [Locale.Pt]: 'Invitro Armênia',
        [Locale.Ge]: 'Invitro Armenia',
    },
    synevo: {
        [Locale.Ru]: 'Synevo',
        [Locale.Am]: 'Synevo',
        [Locale.En]: 'Synevo',
        [Locale.Pt]: 'Synevo',
        [Locale.Ge]: 'Synevo',
    },
    LiTechResults: {
        [Locale.Ru]: 'Результаты ЛиТех',
        [Locale.Am]: 'ԼիՏեխ-ի արդյունքներ',
        [Locale.En]: 'LiTech results',
        [Locale.Pt]: 'Resultados LiTech',
        [Locale.Ge]: 'LiTech results',
    },
    ordersDraft: {
        [Locale.Ru]: 'Черновики ордеров',
        [Locale.Am]: 'Պատվերների նախագծեր',
        [Locale.En]: 'Draft orders',
        [Locale.Pt]: 'Rascunhos de pedidos',
        [Locale.Ge]: 'ბრძანებების პროექტი',
    },
    idAndServiceName: {
        [Locale.Ru]: 'ID и название услуги',
        [Locale.Am]: 'Ծառայության ID և անվանում',
        [Locale.En]: 'ID and service name',
        [Locale.Pt]: 'ID e nome do serviço',
        [Locale.Ge]: 'ID and service name',
    },
    serviceName: {
        [Locale.Ru]: 'Название услуги',
        [Locale.Am]: 'Ծառայության անվանում',
        [Locale.En]: 'Service name',
        [Locale.Pt]: 'Nome do serviço',
        [Locale.Ge]: 'სერვისის სახელი',
    },
    noDataOnDate: {
        [Locale.Ru]: 'Нет данных на заданную дату',
        [Locale.Am]: 'Նշված ամսաթվի համար տվյալներ չկան',
        [Locale.En]: 'No data available for the specified date',
        [Locale.Pt]: 'Não há dados disponíveis para a data especificada',
        [Locale.Ge]: 'No data available for the specified date',
    },
    selectReport: {
        [Locale.Ru]: 'Выберите отчет',
        [Locale.Am]: 'Ընտրեք հաշվետվությունը',
        [Locale.En]: 'Select the report',
        [Locale.Pt]: 'Selecione o relatório',
        [Locale.Ge]: 'Select the report',
    },
    downloadReport: {
        [Locale.Ru]: 'Скачать отчет',
        [Locale.Am]: 'Ներբեռնել հաշվետվությունը',
        [Locale.En]: 'Download the report',
        [Locale.Pt]: 'Baixe o relatório',
        [Locale.Ge]: 'Download the report',
    },
    reportDate: {
        [Locale.Ru]: 'Дата отчета',
        [Locale.Am]: 'Հաշվետվության ամսաթիվ',
        [Locale.En]: 'Report date',
        [Locale.Pt]: 'Data do relatório',
        [Locale.Ge]: 'Report date',
    },
    paymentAct: {
        [Locale.Ru]: 'Акт об оплате',
        [Locale.Am]: 'Վճարման ակտ',
        [Locale.En]: 'Payment act',
        [Locale.Pt]: 'Ato de pagamento',
        [Locale.Ge]: 'Payment act',
    },
    paymentActOnEng: {
        [Locale.Ru]: 'Акт об оплате на английском',
        [Locale.Am]: 'Վճարման ակտ անգլերենով',
        [Locale.En]: 'Payment act in English',
        [Locale.Pt]: 'Ato de pagamento em inglês',
        [Locale.Ge]: 'Payment act in English',
    },
    generatePaymentLink: {
        [Locale.Ru]: 'Сгенерировать ссылку на оплату',
        [Locale.Am]: 'Գեներացնել վճարման հղում',
        [Locale.En]: 'Generate payment link',
        [Locale.Pt]: 'Gerar link de pagamento',
        [Locale.Ge]: 'Generate payment link',
    },
    changeReceived: {
        [Locale.Ru]: 'Получена сдача',
        [Locale.Am]: 'Ստացվել է մանրադրամ',
        [Locale.En]: 'Change received',
        [Locale.Pt]: 'Alteração recebida',
        [Locale.Ge]: 'Change received',
    },
    accountBalance: {
        [Locale.Ru]: 'Остаток на счету',
        [Locale.Am]: 'Հաշվի մնացորդ',
        [Locale.En]: 'Account balance',
        [Locale.Pt]: 'Saldo da conta',
        [Locale.Ge]: 'Account balance',
    },
    printingReceipt: {
        [Locale.Ru]: 'Печать чека',
        [Locale.Am]: 'Կտրոնի տպում',
        [Locale.En]: 'Printing a receipt',
        [Locale.Pt]: 'Imprimindo um recibo',
        [Locale.Ge]: 'Printing a receipt',
    },
    diagnosisAdded: {
        [Locale.Ru]: 'Добавлен диагноз',
        [Locale.Am]: 'Ախտորոշումն ավելացված է',
        [Locale.En]: 'Diagnosis added',
        [Locale.Pt]: 'Diagnóstico adicionado',
        [Locale.Ge]: 'Diagnosis added',
    },
    diagnosisRemoved: {
        [Locale.Ru]: 'Удален диагноз',
        [Locale.Am]: 'Ախտորոշումը ջնջված է',
        [Locale.En]: 'Diagnosis removed',
        [Locale.Pt]: 'Diagnóstico removido',
        [Locale.Ge]: 'Diagnosis removed',
    },
    paymentAmountChange: {
        [Locale.Ru]: 'Изменена сумма оплаты',
        [Locale.Am]: 'Վճարման գումարը փոփոխվել է',
        [Locale.En]: 'Payment amount changed',
        [Locale.Pt]: 'Valor do pagamento alterado',
        [Locale.Ge]: 'Payment amount changed',
    },
    programAdded: {
        [Locale.Ru]: 'Добавлена программа',
        [Locale.Am]: 'Ծրագիրն ավելացված է',
        [Locale.En]: 'Added to the program',
        [Locale.Pt]: 'Adicionado ao programa',
        [Locale.Ge]: 'Added to the program',
    },
    programChanged: {
        [Locale.Ru]: 'Изменена программа',
        [Locale.Am]: 'Ծրագիրը փոփոխվել է',
        [Locale.En]: 'Program changed',
        [Locale.Pt]: 'Programa alterado',
        [Locale.Ge]: 'Program changed',
    },
    programRemoved: {
        [Locale.Ru]: 'Удалена программа',
        [Locale.Am]: 'Ծրագիրը ջնջվել է',
        [Locale.En]: 'The program has been removed',
        [Locale.Pt]: 'O programa foi removido',
        [Locale.Ge]: 'The program has been removed',
    },
    changeOfStatus: {
        [Locale.Ru]: 'Изменение статуса',
        [Locale.Am]: 'Կարգավիճակի փոփոխություն',
        [Locale.En]: 'Change of status',
        [Locale.Pt]: 'Mudança de status',
        [Locale.Ge]: 'Change of status',
    },
    debtFromAccount: {
        [Locale.Ru]: 'Списание со счета',
        [Locale.Am]: 'Դուրսգրում հաշվից',
        [Locale.En]: 'Debiting from the account',
        [Locale.Pt]: 'Débito da conta',
        [Locale.Ge]: 'Debiting from the account',
    },
    historyOfChanges: {
        [Locale.Ru]: 'История изменений',
        [Locale.Am]: 'Փոփոխությունների պատմություն',
        [Locale.En]: 'History of changes',
        [Locale.Pt]: 'Histórico de mudanças',
        [Locale.Ge]: 'History of changes',
    },
    insuranceEditing: {
        [Locale.Ru]: 'Редактирование страховой программы и скидки',
        [Locale.Am]: 'Ապահովագրական ծրագրի և զեղչի խմբագրում',
        [Locale.En]: 'Editing an insurance program and discounts',
        [Locale.Pt]: 'Editando um programa de seguro e descontos',
        [Locale.Ge]: 'Editing an insurance program and discounts',
    },
    insurancePrograms: {
        [Locale.Ru]: 'Страховые программы',
        [Locale.Am]: 'Ապահովագրական ծրագրեր',
        [Locale.En]: 'Insurance programs',
        [Locale.Pt]: 'Programas de seguros',
        [Locale.Ge]: 'Insurance programs',
    },
    billPayment: {
        [Locale.Ru]: 'Оплата счета',
        [Locale.Am]: 'Հաշվի վճարում',
        [Locale.En]: 'Bill payment',
        [Locale.Pt]: 'Pagamento de contas',
        [Locale.Ge]: 'Bill payment',
    },
    servicesSelected: {
        [Locale.Ru]: 'Выбрано услуг',
        [Locale.Am]: 'Ընտրված ծառայություններ',
        [Locale.En]: 'Services selected',
        [Locale.Pt]: 'Serviços selecionados',
        [Locale.Ge]: 'Services selected',
    },
    paymentCopied: {
        [Locale.Ru]: 'Ссылка на оплату скопирована в буфер обмена',
        [Locale.Am]: 'Վճարման հղումը պատճենվել է սեղմատախտակին',
        [Locale.En]: 'Payment link copied to clipboard',
        [Locale.Pt]: 'Link de pagamento copiado para a área de transferência',
        [Locale.Ge]: 'Payment link copied to clipboard',
    },
    sendLinkTo: {
        [Locale.Ru]: 'Отправить ссылку на',
        [Locale.Am]: 'Ուղարկել հղումը՝',
        [Locale.En]: 'Send link to',
        [Locale.Pt]: 'Enviar link para',
        [Locale.Ge]: 'Send link to',
    },
    sendLink: {
        [Locale.Ru]: 'Отправить ссылку',
        [Locale.Am]: 'Ուղարկել հղումը',
        [Locale.En]: 'Send link',
        [Locale.Pt]: 'Enviar link',
        [Locale.Ge]: 'Send link',
    },
    send: {
        [Locale.Ru]: 'Отправить',
        [Locale.Am]: 'Ուղարկել',
        [Locale.En]: 'Send',
        [Locale.Pt]: 'Enviar',
        [Locale.Ge]: 'Send',
    },
    sendChatInvite: {
        [Locale.Ru]: 'Отправить приглашение в чат',
        [Locale.Am]: 'Ուղարկել հրավեր չաթ',
        [Locale.En]: 'Send a chat invitation',
        [Locale.Pt]: 'Envie um convite para bate-papo',
        [Locale.Ge]: 'Send a chat invitation',
    },
    refill: {
        [Locale.Ru]: 'Пополнение счета',
        [Locale.Am]: 'Հաշվի համալրում',
        [Locale.En]: 'Refill',
        [Locale.Pt]: 'Reabastecer',
        [Locale.Ge]: 'Refill',
    },
    errorOccured: {
        [Locale.Ru]: 'Произошла ошибка',
        [Locale.Am]: 'Առաջացել է սխալ',
        [Locale.En]: 'An error has occurred',
        [Locale.Pt]: 'Ocorreu um erro',
        [Locale.Ge]: 'An error has occurred',
    },
    paymentViaLink: {
        [Locale.Ru]: 'Оплата по ссылке',
        [Locale.Am]: 'Վճարում հղումով',
        [Locale.En]: 'Payment via link',
        [Locale.Pt]: 'Pagamento por link',
        [Locale.Ge]: 'Payment via link',
    },
    noPhoneNumber: {
        [Locale.Ru]: 'Не указан номер телефона',
        [Locale.Am]: 'Հեռախոսահամարը նշված չէ',
        [Locale.En]: 'No phone number provided',
        [Locale.Pt]: 'Nenhum número de telefone fornecido',
        [Locale.Ge]: 'No phone number provided',
    },
    topUpAt: {
        [Locale.Ru]: 'Пополнить на',
        [Locale.Am]: 'Համալրել՝',
        [Locale.En]: 'Top up at',
        [Locale.Pt]: 'Recarregue em',
        [Locale.Ge]: 'Top up at',
    },
    topUp: {
        [Locale.Ru]: 'Пополнить',
        [Locale.Am]: 'Համալրել',
        [Locale.En]: 'Top up',
        [Locale.Pt]: 'Recarregar',
        [Locale.Ge]: 'Top up',
    },
    commission: {
        [Locale.Ru]: 'Комиссия',
        [Locale.Am]: 'Միջնորդավճար',
        [Locale.En]: 'Commission',
        [Locale.Pt]: 'Comissão',
        [Locale.Ge]: 'Commission',
    },
    preferredPaymentMethod: {
        [Locale.Ru]: 'Предпочтительный способ оплаты',
        [Locale.Am]: 'Նախընտրելի վճարման եղանակ',
        [Locale.En]: 'Preferred payment method',
        [Locale.Pt]: 'Método de pagamento preferido',
        [Locale.Ge]: 'Preferred payment method',
    },
    paymentMethod: {
        [Locale.Ru]: 'Способ оплаты',
        [Locale.Am]: 'Վճարման եղանակ',
        [Locale.En]: 'Payment method',
        [Locale.Ge]: 'Payment method',
        [Locale.Pt]: 'Método de pagamento',
    },
    addedToYourPersonalAccount: {
        [Locale.En]: 'Добавленные в личном кабинете',
        [Locale.Ru]: 'Добавленные в личном кабинете',
        [Locale.Am]: 'Ավելացվածներ անձնական հաշվում',
        [Locale.Ge]: 'Added to your personal account',
        [Locale.Pt]: 'Adicionado à sua conta pessoal',
    },
    otherMethods: {
        [Locale.En]: 'Другие способы',
        [Locale.Ru]: 'Другие способы',
        [Locale.Am]: 'Այլ եղանակներ',
        [Locale.Ge]: 'Other methods',
        [Locale.Pt]: 'Outros métodos',
    },
    bindPaymentMethod: {
        [Locale.Ru]: 'Привязать способ оплаты',
        [Locale.Am]: 'Կցել վճարման եղանակը',
        [Locale.En]: 'Link payment method',
        [Locale.Pt]: 'Vincular método de pagamento',
        [Locale.Ge]: 'Link payment method',
    },
    paymentMethodBinding: {
        [Locale.Ru]: 'Привязка способа оплаты',
        [Locale.Am]: 'Վճարման եղանակի կցում',
        [Locale.En]: 'Linking a payment method',
        [Locale.Pt]: 'Vinculação do método de pagamento',
        [Locale.Ge]: 'Linking a payment method',
    },
    tbankSbpBinding: {
        [Locale.Ru]: 'Т-Банк - СБП',
        [Locale.Am]: 'T-Bank - SBP',
        [Locale.En]: 'T-Bank - SBP',
        [Locale.Pt]: 'T-Bank - SBP',
        [Locale.Ge]: 'T-Bank - SBP',
    },
    tbankCardBinding: {
        [Locale.Ru]: 'Т-Банк - Карта',
        [Locale.Am]: 'T-Bank - Քարտ',
        [Locale.En]: 'T-Bank - Card',
        [Locale.Pt]: 'T-Bank - Cartão',
        [Locale.Ge]: 'T-Bank - Card',
    },
    noPaymentMethodsToBind: {
        [Locale.Ru]: 'Нет способов оплаты, которые можно привязать',
        [Locale.Am]: 'Կցելու համար վճարման եղանակներ չկան',
        [Locale.En]: 'No payment methods available to link',
        [Locale.Pt]: 'Não há métodos de pagamento disponíveis para vincular',
        [Locale.Ge]: 'No payment methods available to link',
    },
    generateBindingLink: {
        [Locale.Ru]: 'Сформировать ссылку на привязку',
        [Locale.Am]: 'Գեներացնել կցման հղում',
        [Locale.En]: 'Generate linking URL',
        [Locale.Pt]: 'Gerar link de vinculação',
        [Locale.Ge]: 'Generate linking URL',
    },
    bindingLinkCopied: {
        [Locale.Ru]: 'Ссылка на привязку скопирована в буфер обмена',
        [Locale.Am]: 'Կցման հղումը պատճենվել է սեղմատախտակին',
        [Locale.En]: 'Linking URL copied to clipboard',
        [Locale.Pt]: 'Link de vinculação copiado para a área de transferência',
        [Locale.Ge]: 'Linking URL copied to clipboard',
    },
    bindingUrlText: {
        [Locale.Ru]: 'Ссылка для привязки способа оплаты',
        [Locale.Am]: 'Վճարման եղանակի կցման հղում',
        [Locale.En]: 'Payment method linking URL',
        [Locale.Pt]: 'Link para vincular o método de pagamento',
        [Locale.Ge]: 'Payment method linking URL',
    },
    default: {
        [Locale.Ru]: 'По-умолчанию',
        [Locale.Am]: 'Լռելյայն',
        [Locale.En]: 'Default',
        [Locale.Pt]: 'Padrão',
        [Locale.Ge]: 'Default',
    },
    creditPersonalAccount: {
        [Locale.Ru]: 'Зачислить на личный счет',
        [Locale.Am]: 'Մուտքագրել անձնական հաշվին',
        [Locale.En]: 'Credit to personal account',
        [Locale.Pt]: 'Crédito em conta pessoal',
        [Locale.Ge]: 'Credit to personal account',
    },
    throughAccounting: {
        [Locale.Ru]: 'Через бухгалтерию',
        [Locale.Am]: 'Հաշվապահության միջոցով',
        [Locale.En]: 'Through accounting',
        [Locale.Pt]: 'Através da contabilidade',
        [Locale.Ge]: 'ბუღალტრიის მეშვეობით',
    },
    byPaymentMethod: {
        [Locale.Ru]: 'Методом оплаты',
        [Locale.Am]: 'Վճարման եղանակով',
        [Locale.En]: 'By payment method',
        [Locale.Pt]: 'Pelo método de pagamento',
        [Locale.Ge]: 'გადახდის მეთოდით',
    },
    withReceipt: {
        [Locale.Ru]: 'С чеком',
        [Locale.Am]: 'Կտրոնով',
        [Locale.En]: 'With receipt',
        [Locale.Pt]: 'Com recibo',
        [Locale.Ge]: 'ქვითრით',
    },
    withoutReceipt: {
        [Locale.Ru]: 'Без чека',
        [Locale.Am]: 'Առանց կտրոնի',
        [Locale.En]: 'Without receipt',
        [Locale.Pt]: 'Sem recibo',
        [Locale.Ge]: 'ქვითრის გარეშე',
    },
    changeStatus: {
        [Locale.Ru]: 'Изменить статус',
        [Locale.Am]: 'Փոփոխել կարգավիճակը',
        [Locale.En]: 'Change status',
        [Locale.Pt]: 'vou mudar meu estado',
        [Locale.Ge]: 'Change status',
    },
    past: {
        [Locale.Ru]: 'Прошедшие',
        [Locale.Am]: 'Անցածներ',
        [Locale.En]: 'Past',
        [Locale.Pt]: 'Passado',
        [Locale.Ge]: 'Past',
    },
    shiftCost: {
        [Locale.Ru]: 'Ставка за смену',
        [Locale.Am]: 'Հերթափոխի դրույքաչափ',
        [Locale.En]: 'Shift cost',
        [Locale.Pt]: 'Custo de turno',
        [Locale.Ge]: 'Shift cost',
    },
    profitPercentage: {
        [Locale.Ru]: 'Процент операционной прибыли',
        [Locale.Am]: 'Գործառնական շահույթի տոկոս',
        [Locale.En]: 'Profit percentage',
        [Locale.Pt]: 'Porcentagem de lucro',
        [Locale.Ge]: 'Profit percentage',
    },
    editRSStatus: {
        [Locale.Ru]: 'Редактирование статуса оказанной услуги',
        [Locale.Am]: 'Մատուցված ծառայության կարգավիճակի խմբագրում',
        [Locale.En]: 'Editing the status of a service provided',
        [Locale.Pt]: 'Editando o status de um serviço prestado',
        [Locale.Ge]: 'Editing the status of a service provided',
    },
    creatingEhr: {
        [Locale.Ru]: 'Создание карты',
        [Locale.Am]: 'Քարտի ստեղծում',
        [Locale.En]: 'Creating a ehr',
        [Locale.Pt]: 'Criando um ehr',
        [Locale.Ge]: 'Creating a ehr',
    },
    addPrice: {
        [Locale.Ru]: 'Добавить цену',
        [Locale.Am]: 'Ավելացնել գին',
        [Locale.En]: 'Add price',
        [Locale.Pt]: 'Adicionar preço',
        [Locale.Ge]: 'Add price',
    },
    addReferenceTable: {
        [Locale.Ru]: 'Добавить таблицу референсов',
        [Locale.Am]: 'Ավելացնել ռեֆերենսների աղյուսակ',
        [Locale.En]: 'Add reference table',
        [Locale.Pt]: 'Adicionar tabela de referência',
        [Locale.Ge]: 'Add reference table',
    },
    addReference: {
        [Locale.Ru]: 'Добавить референс',
        [Locale.Am]: 'Ավելացնել ռեֆերենս',
        [Locale.En]: 'Add reference',
        [Locale.Pt]: 'Adicionar referência',
        [Locale.Ge]: 'Add reference',
    },
    basePrice: {
        [Locale.Ru]: 'Базовая цена',
        [Locale.Am]: 'Բազային գին',
        [Locale.En]: 'Base price',
        [Locale.Pt]: 'Preço base',
        [Locale.Ge]: 'Base price',
    },
    addService: {
        [Locale.Ru]: 'Добавить услугу',
        [Locale.Am]: 'Ավելացնել ծառայություն',
        [Locale.En]: 'Add service',
        [Locale.Pt]: 'Adicionar serviço',
        [Locale.Ge]: 'Add service',
    },
    profileSettings: {
        [Locale.Ru]: 'Настройки профиля',
        [Locale.Am]: 'Պրոֆիլի կարգավորումներ',
        [Locale.En]: 'Profile Settings',
        [Locale.Pt]: 'Configurações de perfil',
        [Locale.Ge]: 'Profile Settings',
    },
    profileData: {
        [Locale.Ru]: 'Данные профиля',
        [Locale.Am]: 'Պրոֆիլի տվյալներ',
        [Locale.En]: 'Profile data',
        [Locale.Pt]: 'Dados do perfil',
        [Locale.Ge]: 'Profile data',
    },
    canBeEpisodeManager: {
        [Locale.Ru]: 'Может быть менеджером эпизода',
        [Locale.Am]: 'Կարող է լինել էպիզոդի մենեջեր',
        [Locale.En]: 'Can be episode manager',
        [Locale.Pt]: 'Pode ser gerenciador de episódios',
        [Locale.Ge]: 'Can be episode manager',
    },
    loginAs: {
        [Locale.Ru]: 'Залогиниться как',
        [Locale.Am]: 'Մուտք գործել որպես',
        [Locale.En]: 'Login as',
        [Locale.Pt]: 'Faça login como',
        [Locale.Ge]: 'Login as',
    },
    profileUrl: {
        [Locale.Ru]: 'Ссылка на профиль',
        [Locale.Am]: 'Պրոֆիլի հղում',
        [Locale.En]: 'Profile url',
        [Locale.Pt]: 'URL do perfil',
        [Locale.Ge]: 'Profile url',
    },
    emailForCommunication: {
        [Locale.Ru]: 'E-mail для связи',
        [Locale.Am]: 'Կապի էլ. հասցե',
        [Locale.En]: 'Email for communication',
        [Locale.Pt]: 'E-mail para comunicação',
        [Locale.Ge]: 'Email for communication',
    },
    cityPhone: {
        [Locale.Ru]: 'Номер телефона практики',
        [Locale.Am]: 'Պրակտիկայի հեռախոսահամար',
        [Locale.En]: 'Practice phone number',
        [Locale.Pt]: 'Pratique o número de telefone',
        [Locale.Ge]: 'Practice phone number',
    },
    extensionNumber: {
        [Locale.Ru]: 'Внутренний номер',
        [Locale.Am]: 'Ներքին համար',
        [Locale.En]: 'Extension number',
        [Locale.Pt]: 'Número do ramal',
        [Locale.Ge]: 'Extension number',
    },
    redirectFromNumber: {
        [Locale.Ru]: 'Редирект с номера',
        [Locale.Am]: 'Վերահասցեավորում համարից',
        [Locale.En]: 'Redirect from number',
        [Locale.Pt]: 'Redirecionar do número',
        [Locale.Ge]: 'Redirect from number',
    },
    phoneForForwarding: {
        [Locale.Ru]: 'Номер телефона для переадресации',
        [Locale.Am]: 'Հեռախոսահամար վերահասցեավորման համար',
        [Locale.En]: 'Phone number for forwarding',
        [Locale.Pt]: 'Número de telefone para encaminhamento',
        [Locale.Ge]: 'Phone number for forwarding',
    },
    changePassword: {
        [Locale.Ru]: 'Изменить пароль',
        [Locale.Am]: 'Փոփոխել գաղտնաբառը',
        [Locale.En]: 'Change password',
        [Locale.Pt]: 'Alterar a senha',
        [Locale.Ge]: 'Change password',
    },
    generatePassword: {
        [Locale.Ru]: 'Сгенерировать пароль',
        [Locale.Am]: 'Գեներացնել գաղտնաբառ',
        [Locale.En]: 'Generate password',
        [Locale.Pt]: 'Gerar senha',
        [Locale.Ge]: 'Generate password',
    },
    editEntryDoctor: {
        [Locale.Ru]: 'Редактировать доктора записи',
        [Locale.Am]: 'Խմբագրել գրառման բժշկին',
        [Locale.En]: 'Edit Doctor Record',
        [Locale.Pt]: 'Editar registro médico',
        [Locale.Ge]: 'Edit Doctor Record',
    },
    currentDoctor: {
        [Locale.Ru]: 'Текущий доктор',
        [Locale.Am]: 'Ընթացիկ բժիշկ',
        [Locale.En]: 'Current doctor',
        [Locale.Pt]: 'Médico atual',
        [Locale.Ge]: 'Current doctor',
    },
    newDoctor: {
        [Locale.Ru]: 'Новый доктор',
        [Locale.Am]: 'Նոր բժիշկ',
        [Locale.En]: 'New doctor',
        [Locale.Pt]: 'Novo médico',
        [Locale.Ge]: 'New doctor',
    },
    editVisitDate: {
        [Locale.Ru]: 'Редактирование даты приема',
        [Locale.Am]: 'Ընդունելության ամսաթվի խմբագրում',
        [Locale.En]: 'Editing the appointment date',
        [Locale.Pt]: 'Editando a data do compromisso',
        [Locale.Ge]: 'Editing the appointment date',
    },
    currentVisitDate: {
        [Locale.Ru]: 'Текущая дата приема',
        [Locale.Am]: 'Ընդունելության ընթացիկ ամսաթիվ',
        [Locale.En]: 'Current appointment date',
        [Locale.Pt]: 'Data atual do compromisso',
        [Locale.Ge]: 'Current appointment date',
    },
    newVisitDate: {
        [Locale.Ru]: 'Новая дата приема',
        [Locale.Am]: 'Ընդունելության նոր ամսաթիվ',
        [Locale.En]: 'New appointment date',
        [Locale.Pt]: 'Nova data de consulta',
        [Locale.Ge]: 'New appointment date',
    },
    createEpisode: {
        [Locale.Ru]: 'Создать эпизод',
        [Locale.Am]: 'Ստեղծել էպիզոդ',
        [Locale.En]: 'Create episode',
        [Locale.Pt]: 'Criar episódio',
        [Locale.Ge]: 'Create episode',
    },
    whatToDO: {
        [Locale.Ru]: 'Что сделать',
        [Locale.Am]: 'Ինչ անել',
        [Locale.En]: 'What to do',
        [Locale.Pt]: 'O que fazer',
        [Locale.Ge]: 'What to do',
    },
    failedToChangeStatus: {
        [Locale.Ru]: 'Не удалось изменить статус',
        [Locale.Am]: 'Չհաջողվեց փոփոխել կարգավիճակը',
        [Locale.En]: 'Failed to change status',
        [Locale.Pt]: 'Falha ao alterar o status',
        [Locale.Ge]: 'Failed to change status',
    },
    sameEhrAlreadeExist: {
        [Locale.Ru]: 'Карта с этими данными уже существует',
        [Locale.Am]: 'Այս տվյալներով քարտ արդեն գոյություն ունի',
        [Locale.En]: 'Ehr with this data already exists',
        [Locale.Pt]: 'Ehr com esses dados já existe',
        [Locale.Ge]: 'Ehr with this data already exists',
    },
    useExisingFem: {
        [Locale.Ru]: 'Воспользоваться существующей',
        [Locale.Am]: 'Օգտվել առկայից',
        [Locale.En]: 'Take advantage of an existing one',
        [Locale.Pt]: 'Aproveite um já existente',
        [Locale.Ge]: 'Take advantage of an existing one',
    },
    addDestination: {
        [Locale.Ru]: 'Добавить назначение',
        [Locale.Am]: 'Ավելացնել նշանակում',
        [Locale.En]: 'Add destination',
        [Locale.Pt]: 'Adicionar destino',
        [Locale.Ge]: 'Add destination',
    },
    addAnotherLanguage: {
        [Locale.Ru]: 'Добавить название на другом языке',
        [Locale.Am]: 'Ավելացնել անվանում այլ լեզվով',
        [Locale.En]: 'Add a title in another language',
        [Locale.Pt]: 'Adicione um título em outro idioma',
        [Locale.Ge]: 'Add a title in another language',
    },
    selectLanguageAndEnterName: {
        [Locale.Ru]: 'Выберите язык и введите название',
        [Locale.Am]: 'Ընտրեք լեզուն և մուտքագրեք անվանումը',
        [Locale.En]: 'Select language and enter name',
        [Locale.Pt]: 'Selecione o idioma e digite o nome',
        [Locale.Ge]: 'Select language and enter name',
    },
    informationNotSaved: {
        [Locale.Ru]: 'Информация не сохранилась',
        [Locale.Am]: 'Տեղեկությունը չի պահպանվել',
        [Locale.En]: 'Information not saved',
        [Locale.Pt]: 'Informações não salvas',
        [Locale.Ge]: 'Information not saved',
    },
    errorWhileSavingData: {
        [Locale.Ru]: 'Возникла ошибка при сохранении данных',
        [Locale.Am]: 'Տվյալները պահպանելիս առաջացել է սխալ',
        [Locale.En]: 'An error occurred while saving data',
        [Locale.Pt]: 'Ocorreu um erro ao salvar os dados',
        [Locale.Ge]: 'An error occurred while saving data',
    },
    publications: {
        [Locale.Ru]: 'Научная деятельность, публикации',
        [Locale.Am]: 'Գիտական գործունեություն, հրապարակումներ',
        [Locale.En]: 'Publications',
        [Locale.Pt]: 'Publicações',
        [Locale.Ge]: 'Publications',
    },
    reasonForWork: {
        [Locale.Ru]: 'Почему я работаю в Чайке?',
        [Locale.Am]: 'Ինչո՞ւ եմ աշխատում Չայկայում',
        [Locale.En]: 'Reason for work',
        [Locale.Pt]: 'Motivo do trabalho',
        [Locale.Ge]: 'Reason for work',
    },
    reason: {
        [Locale.Ru]: 'Причина',
        [Locale.Am]: 'Պատճառ',
        [Locale.En]: 'Reason',
        [Locale.Pt]: 'Razão',
        [Locale.Ge]: 'Reason',
    },
    entryDeleting: {
        [Locale.Ru]: 'Удаление записи',
        [Locale.Am]: 'Գրառման ջնջում',
        [Locale.En]: 'Deleting an entry',
        [Locale.Pt]: 'Excluindo uma entrada',
        [Locale.Ge]: 'Deleting an entry',
    },
    areYouSgureDeleteEntry: {
        [Locale.Ru]: 'Вы действительно хотите удалить запись',
        [Locale.Am]: 'Իսկապե՞ս ուզում եք ջնջել գրառումը',
        [Locale.En]: 'Are you sure you want to delete the entry',
        [Locale.Pt]: 'Tem certeza de que deseja excluir a entrada',
        [Locale.Ge]: 'Are you sure you want to delete the entry',
    },
    entryOptions: {
        [Locale.Ru]: 'Параметры записи',
        [Locale.Am]: 'Գրառման պարամետրեր',
        [Locale.En]: 'Entry options',
        [Locale.Pt]: 'Opções de entrada',
        [Locale.Ge]: 'Entry options',
    },
    replyToReferral: {
        [Locale.Ru]: 'Ответ на направление',
        [Locale.Am]: 'Պատասխան ուղեգրին',
        [Locale.En]: 'Reply to referral',
        [Locale.Pt]: 'Responder à referência',
        [Locale.Ge]: 'Reply to referral',
    },
    dataForLaboratory: {
        [Locale.Ru]: 'Данные для лаборатории',
        [Locale.Am]: 'Տվյալներ լաբորատորիայի համար',
        [Locale.En]: 'Data for the laboratory',
        [Locale.Pt]: 'Dados para o laboratório',
        [Locale.Ge]: 'Data for the laboratory',
    },
    dataForContractor: {
        [Locale.Ru]: 'Данные подрядчика',
        [Locale.Am]: 'Կապալառուի տվյալներ',
        [Locale.En]: 'Contractor data',
        [Locale.Pt]: 'Dados do contratante',
        [Locale.Ge]: 'Contractor data',
    },
    chooseLaboratory: {
        [Locale.Ru]: 'Выберите лабораторию',
        [Locale.Am]: 'Ընտրեք լաբորատորիան',
        [Locale.En]: 'Choose laboratory',
        [Locale.Pt]: 'Escolha o laboratório',
        [Locale.Ge]: 'Choose laboratory',
    },
    appointmentViaChat: {
        [Locale.Ru]: 'Запись через чат',
        [Locale.Am]: 'Գրանցում չաթի միջոցով',
        [Locale.En]: 'Appointment Via Chat',
        [Locale.Pt]: 'Agendamento via chat',
        [Locale.Ge]: 'Appointment Via Chat',
    },
    appointmentViaChatOnly: {
        [Locale.Ru]: 'Запись только через чат',
        [Locale.Am]: 'Գրանցում միայն չաթի միջոցով',
        [Locale.En]: 'Appointment only via chat',
        [Locale.Pt]: 'Agendamento apenas via chat',
        [Locale.Ge]: 'Appointment only via chat',
    },
    canBeInMultipleOffices: {
        [Locale.Ru]: 'Может быть в нескольких кабинетах одновременно',
        [Locale.Am]: 'Կարող է լինել մի քանի կաբինետում միաժամանակ',
        [Locale.En]: 'Can be in multiple offices at the same time',
        [Locale.Pt]: 'Pode estar em vários consultórios ao mesmo tempo',
        [Locale.Ge]: 'Can be in multiple offices at the same time',
    },
    slotsOnSite: {
        [Locale.Ru]: 'Слоты на сайте',
        [Locale.Am]: 'Սլոտները կայքում',
        [Locale.En]: 'Slots on the site',
        [Locale.Pt]: 'Horários no site',
        [Locale.Ge]: 'Slots on the site',
    },
    slotDurationInMinutes: {
        [Locale.Ru]: 'Длительность слота (в минутах)',
        [Locale.Am]: 'Սլոտի տևողությունը (րոպեներով)',
        [Locale.En]: 'Slot duration (in minutes)',
        [Locale.Pt]: 'Duração do horário (em minutos)',
        [Locale.Ge]: 'Slot duration (in minutes)',
    },
    slotPriceInOrganizationCurrency: {
        [Locale.Ru]: 'Цена слота (в валюте организации)',
        [Locale.Am]: 'Սլոտի գինը (կազմակերպության արժույթով)',
        [Locale.En]: 'Slot price (in organization currency)',
        [Locale.Pt]: 'Preço do horário (na moeda da organização)',
        [Locale.Ge]: 'Slot price (in organization currency)',
    },
    minAge: {
        [Locale.Ru]: 'Минимальный возраст',
        [Locale.Am]: 'Նվազագույն տարիք',
        [Locale.En]: 'Minimum age',
        [Locale.Pt]: 'Idade mínima',
        [Locale.Ge]: 'Minimum age',
    },
    minAgeShort: {
        [Locale.Ru]: 'Мин. возраст',
        [Locale.Am]: 'Նվազ. տարիք',
        [Locale.En]: 'Min age',
        [Locale.Pt]: 'Minha idade',
        [Locale.Ge]: 'Min age',
    },
    minAgeFrom: {
        [Locale.Ru]: 'С $age $unit',
        [Locale.Am]: '$age տարեկանից',
        [Locale.En]: 'From $age $unit',
        [Locale.Pt]: 'A partir de $age $unit',
        [Locale.Ge]: 'From $age $unit',
    },
    maxAgeTo: {
        [Locale.Ru]: 'До $age $unit',
        [Locale.Am]: 'Մինչև $age տարեկան',
        [Locale.En]: 'Up to $age $unit',
        [Locale.Pt]: 'Até $age $unit',
        [Locale.Ge]: 'Up to $age $unit',
    },
    ageRange: {
        [Locale.Ru]: 'С $min до $max $unit',
        [Locale.Am]: '$min-ից $max տարեկան',
        [Locale.En]: 'From $min to $max $unit',
        [Locale.Pt]: 'De $min a $max $unit',
        [Locale.Ge]: 'From $min to $max $unit',
    },
    ageUnlimited: {
        [Locale.Ru]: 'Возраст неограничен',
        [Locale.Am]: 'Տարիքը սահմանափակված չէ',
        [Locale.En]: 'No age limit',
        [Locale.Pt]: 'Sem limite de idade',
        [Locale.Ge]: 'No age limit',
    },
    maxAge: {
        [Locale.Ru]: 'Максимальный возраст',
        [Locale.Am]: 'Առավելագույն տարիք',
        [Locale.En]: 'Maximum age',
        [Locale.Pt]: 'Idade máxima',
        [Locale.Ge]: 'Maximum age',
    },
    defaultMinAge: {
        [Locale.Ru]: 'Минимальный возраст по умолчанию',
        [Locale.Am]: 'Լռելյայն նվազագույն տարիք',
        [Locale.En]: 'Default minimum age',
        [Locale.Pt]: 'Idade mínima padrão',
        [Locale.Ge]: 'Default minimum age',
    },
    maxPatientCount: {
        [Locale.Ru]: 'Максимальное количество пациентов',
        [Locale.Am]: 'Պացիենտների առավելագույն քանակ',
        [Locale.En]: 'Maximum number of patients',
        [Locale.Pt]: 'Número máximo de pacientes',
        [Locale.Ge]: 'Maximum number of patients',
    },
    channelType: {
        [Locale.Ru]: 'Способ получения',
        [Locale.Am]: 'Ստացման եղանակ',
        [Locale.En]: 'Method of obtaining',
        [Locale.Pt]: 'Método de obtenção',
        [Locale.Ge]: 'Method of obtaining',
    },
    receivingChannel: {
        [Locale.Ru]: 'Канал получения',
        [Locale.Am]: 'Ստացման ալիք',
        [Locale.En]: 'Receiving channel',
        [Locale.Pt]: 'Canal de recepção',
        [Locale.Ge]: 'Receiving channel',
    },
    notDoneYet: {
        [Locale.Ru]: 'Ещё не выполнено',
        [Locale.Am]: 'Դեռ կատարված չէ',
        [Locale.En]: 'Not done yet',
        [Locale.Pt]: 'Ainda não foi feito',
        [Locale.Ge]: 'Not done yet',
    },
    addedFiles: {
        [Locale.Ru]: 'Добавленные файлы',
        [Locale.Am]: 'Ավելացված ֆայլեր',
        [Locale.En]: 'Added files',
        [Locale.Pt]: 'Arquivos adicionados',
        [Locale.Ge]: 'Added files',
    },
    addedToFavorite: {
        [Locale.Ru]: 'Добавлено в избранное',
        [Locale.Am]: 'Ավելացվել է ընտրյալներում',
        [Locale.En]: 'Added to favorites',
        [Locale.Pt]: 'Adicionado aos favoritos',
        [Locale.Ge]: 'Added to favorites',
    },
    postedByDoctor: {
        [Locale.Ru]: 'Поставил доктор',
        [Locale.Am]: 'Դրել է բժիշկը',
        [Locale.En]: 'Posted by doctor',
        [Locale.Pt]: 'Postado pelo médico',
        [Locale.Ge]: 'Posted by doctor',
    },
    vaccinationDetails: {
        [Locale.Ru]: 'Данные о сделанной вакцинации',
        [Locale.Am]: 'Կատարված պատվաստման տվյալներ',
        [Locale.En]: 'Vaccination details',
        [Locale.Pt]: 'Detalhes da vacinação',
        [Locale.Ge]: 'Vaccination details',
    },
    ageAtTime: {
        [Locale.Ru]: 'Возраст на момент',
        [Locale.Am]: 'Տարիքը տվյալ պահին',
        [Locale.En]: 'Age at time',
        [Locale.Pt]: 'Idade na época',
        [Locale.Ge]: 'Age at time',
    },
    goToSchedule: {
        [Locale.Ru]: 'Перейти в расписание',
        [Locale.Am]: 'Անցնել ժամանակացույց',
        [Locale.En]: 'Go to schedule',
        [Locale.Pt]: 'Ir para agendamento',
        [Locale.Ge]: 'Go to schedule',
    },
    canPayByQrOnPlate: {
        [Locale.Ru]: `Можно оплачивать через QR код на табличке`,
        [Locale.Am]: `Կարելի է վճարել ցուցանակի վրայի QR կոդով`,
        [Locale.En]: `You can pay via the QR code on the plate`,
        [Locale.Pt]: 'Você pode pagar através do código QR na placa',
        [Locale.Ge]: `You can pay via the QR code on the plate`,
    },
    hasPayemntButNotLink: {
        [Locale.Ru]: `Оплата создалась, но не получилось найти ссылку`,
        [Locale.Am]: `Վճարումը ստեղծվել է, սակայն չհաջողվեց գտնել հղումը`,
        [Locale.En]: `The payment was created, but the link could not be found`,
        [Locale.Pt]: 'O pagamento foi criado, mas o link não foi encontrado',
        [Locale.Ge]: `The payment was created, but the link could not be found`,
    },
    hasNoFieldsForTranslation: {
        [Locale.Ru]: `Нет полей для перевода`,
        [Locale.Am]: `Թարգմանության համար դաշտեր չկան`,
        [Locale.En]: `No fields for translation`,
        [Locale.Pt]: 'Não há campos para tradução',
        [Locale.Ge]: `No fields for translation`,
    },
    failedToSignEntry: {
        [Locale.Ru]: `Не удалось подписать запись`,
        [Locale.Am]: `Չհաջողվեց ստորագրել գրառումը`,
        [Locale.En]: `Failed to sign entry`,
        [Locale.Pt]: 'Falha ao assinar a entrada',
        [Locale.Ge]: `Failed to sign entry`,
    },
    cdaRequestFailed: {
        [Locale.Ru]: `Не удалось сформировать СЭМД`,
        [Locale.Am]: `Չհաջողվեց ստեղծել CDA փաստաթուղթը`,
        [Locale.En]: `Failed to generate the CDA document`,
        [Locale.Pt]: `Falha ao gerar o documento CDA`,
        [Locale.Ge]: `Failed to generate the CDA document`,
    },
    cdaSigningFailed: {
        [Locale.Ru]: `Не удалось подписать СЭМД`,
        [Locale.Am]: `Չհաջողվեց ստորագրել CDA փաստաթուղթը`,
        [Locale.En]: `Failed to sign the CDA document`,
        [Locale.Pt]: `Falha ao assinar o documento CDA`,
        [Locale.Ge]: `Failed to sign the CDA document`,
    },
    continueWithoutCda: {
        [Locale.Ru]: `Продолжить без СЭМД`,
        [Locale.Am]: `Շարունակել առանց CDA-ի`,
        [Locale.En]: `Continue without CDA`,
        [Locale.Pt]: `Continuar sem CDA`,
        [Locale.Ge]: `Continue without CDA`,
    },
    showAssistant: {
        [Locale.Ru]: `Показать ассистентов`,
        [Locale.Am]: `Ցուցադրել օգնականներին`,
        [Locale.En]: `Show assistant`,
        [Locale.Pt]: 'Mostrar assistente',
        [Locale.Ge]: `Show assistant`,
    },
    referralBindWithOthers: {
        [Locale.Ru]: `Направление связали с другими эпизодами`,
        [Locale.Am]: `Ուղեգիրը կապվել է այլ էպիզոդների հետ`,
        [Locale.En]: `The referral was linked to other episodes`,
        [Locale.Pt]: 'A referência estava vinculada a outros episódios',
        [Locale.Ge]: `The referral was linked to other episodes`,
    },
    accordingToMyEpisodes: {
        [Locale.Ru]: `По моим эпизодам`,
        [Locale.Am]: `Ըստ իմ էպիզոդների`,
        [Locale.En]: `According to my episodes`,
        [Locale.Pt]: 'De acordo com meus episódios',
        [Locale.Ge]: `According to my episodes`,
    },
    referralCreatedInEpisode: {
        [Locale.Ru]: `Направление создано в эпизоде`,
        [Locale.Am]: `Ուղեգիրը ստեղծվել է էպիզոդում`,
        [Locale.En]: `Referral created in episode`,
        [Locale.Pt]: 'Referência criada no episódio',
        [Locale.Ge]: `Referral created in episode`,
    },
    failedToUpdateReferral: {
        [Locale.Ru]: `Не удалось обновить направление`,
        [Locale.Am]: `Չհաջողվեց թարմացնել ուղեգիրը`,
        [Locale.En]: `Failed to update referral`,
        [Locale.Pt]: 'Falha ao atualizar referência',
        [Locale.Ge]: `Failed to update referral`,
    },
    maxLength: {
        [Locale.Ru]: `Максимальная длина`,
        [Locale.Am]: `Առավելագույն երկարություն`,
        [Locale.En]: `Max length`,
        [Locale.Pt]: 'Comprimento máximo',
        [Locale.Ge]: `Max length`,
    },
    paymentCardRequired: {
        [Locale.Ru]: `Обязательная банковская карта`,
        [Locale.Am]: `Պարտադիր բանկային քարտ`,
        [Locale.En]: `Payment card required`,
        [Locale.Pt]: 'É necessário cartão de pagamento',
        [Locale.Ge]: `Payment card required`,
    },
    doNotNotifyPatient: {
        [Locale.Ru]: `Не уведомлять пациента`,
        [Locale.Am]: `Չծանուցել պացիենտին`,
        [Locale.En]: `Do not notify the patient`,
        [Locale.Pt]: 'Não notifique o paciente',
        [Locale.Ge]: `Do not notify the patient`,
    },
    lateCancellationFee: {
        [Locale.Ru]: `Оплата поздней отмены`,
        [Locale.Am]: `Ուշ չեղարկման վճար`,
        [Locale.En]: `Late cancellation fee`,
        [Locale.Pt]: 'Taxa de cancelamento tardio',
        [Locale.Ge]: `Late cancellation fee`,
    },
    finedFrom: {
        [Locale.Ru]: `Платная отмена менее чем (часов)`,
        [Locale.Am]: `Վճարովի չեղարկում պակաս քան (ժամ)`,
        [Locale.En]: `Paid cancellation in less than (hours)`,
        [Locale.Pt]: 'Cancelamento pago em menos de (horas)',
        [Locale.Ge]: `Paid cancellation in less than (hours)`,
    },
    mustSelectService: {
        [Locale.Ru]: `Необходимо выбрать услугу`,
        [Locale.Am]: `Անհրաժեշտ է ընտրել ծառայություն`,
        [Locale.En]: `You must select a service`,
        [Locale.Pt]: 'Você deve selecionar um serviço',
        [Locale.Ge]: `You must select a service`,
    },
    bankCardRequired: {
        [Locale.Ru]: `Банковская карта обязательна`,
        [Locale.Am]: `Բանկային քարտը պարտադիր է`,
        [Locale.En]: `Bank card required`,
        [Locale.Pt]: 'É necessário cartão bancário',
        [Locale.Ge]: `Bank card required`,
    },
    mainOrganization: {
        [Locale.Ru]: `Основная организация`,
        [Locale.Am]: `Հիմնական կազմակերպություն`,
        [Locale.En]: `Main organization`,
        [Locale.Pt]: 'Organização principal',
        [Locale.Ge]: `Main organization`,
    },
    mainService: {
        [Locale.Ru]: `Основная услуга`,
        [Locale.Am]: `Հիմնական ծառայություն`,
        [Locale.En]: `Main service`,
        [Locale.Pt]: 'Serviço principal',
        [Locale.Ge]: `Main service`,
    },
    mainOnlineService: {
        [Locale.Ru]: `Основная онлайн услуга`,
        [Locale.Am]: `Հիմնական առցանց ծառայություն`,
        [Locale.En]: `Main online service`,
        [Locale.Pt]: 'Principal serviço on-line',
        [Locale.Ge]: `Main online service`,
    },
    serviceNotApplayToSpetialty: {
        [Locale.Ru]: `Услуга не относится к выбранной специальности`,
        [Locale.Am]: `Ծառայությունը չի վերաբերում ընտրված մասնագիտությանը`,
        [Locale.En]: `The service does not apply to the chosen specialty`,
        [Locale.Pt]: 'O serviço não se aplica à especialidade escolhida',
        [Locale.Ge]: `The service does not apply to the chosen specialty`,
    },
    mustCompletedForReject: {
        [Locale.Ru]: `Необходимо заполнить, если хотите отклонить задание`,
        [Locale.Am]: `Անհրաժեշտ է լրացնել, եթե ցանկանում եք մերժել առաջադրանքը`,
        [Locale.En]: `Must be completed if you want to decline the assignment.`,
        [Locale.Pt]: 'Deve ser preenchido se você quiser recusar a tarefa.',
        [Locale.Ge]: `Must be completed if you want to decline the assignment.`,
    },
    doesNotNeedReferral: {
        [Locale.Ru]: `Пациенту не нужны направления. Участие других специалистов не требуется`,
        [Locale.Am]: `Պացիենտին ուղեգրեր պետք չեն։ Այլ մասնագետների մասնակցություն չի պահանջվում`,
        [Locale.En]: `The patient does not need referrals. No other specialists required`,
        [Locale.Pt]: 'O paciente não precisa de encaminhamentos. Não são necessários outros especialistas',
        [Locale.Ge]: `The patient does not need referrals. No other specialists required`,
    },
    cantAddReferral: {
        [Locale.Ru]: `Нельзя добавить направление`,
        [Locale.Am]: `Չի կարելի ավելացնել ուղեգիր`,
        [Locale.En]: `Can't add referral`,
        [Locale.Pt]: `Não foi possível adicionar uma referência.`,
        [Locale.Ge]: `Can't add referral`,
    },
    addOffEntryReferralText: {
        [Locale.Ru]: `Направление вне записи можно добавить, только если в эпизоде есть добавленный диагноз`,
        [Locale.Am]: `Գրառումից դուրս ուղեգիր կարելի է ավելացնել միայն այն դեպքում, եթե էպիզոդում կա ավելացված ախտորոշում`,
        [Locale.En]: `An off-record referral can only be added if there is an added diagnosis in the episode.`,
        [Locale.Pt]: 'Um encaminhamento não registrado só pode ser adicionado se houver um diagnóstico adicional no episódio.',
        [Locale.Ge]: `An off-record referral can only be added if there is an added diagnosis in the episode.`,
    },
    addScheduleOnline: {
        [Locale.Ru]: `Добавить расписание онлайн`,
        [Locale.Am]: `Ավելացնել առցանց ժամանակացույց`,
        [Locale.En]: `Add schedule online`,
        [Locale.Pt]: 'Adicionar agendamento on-line',
        [Locale.Ge]: `Add schedule online`,
    },
    numberOfWorkShifts: {
        [Locale.Ru]: `Количество рабочих смен`,
        [Locale.Am]: `Աշխատանքային հերթափոխերի քանակ`,
        [Locale.En]: `Number of work shifts`,
        [Locale.Pt]: 'Número de turnos de trabalho',
        [Locale.Ge]: `Number of work shifts`,
    },
    numberOfWorkShiftsMainAssistant: {
        [Locale.Ru]: `Количество рабочих смен основного ассистента`,
        [Locale.Am]: `Հիմնական օգնականի աշխատանքային հերթափոխերի քանակ`,
        [Locale.En]: `Number of work shifts of the main assistant`,
        [Locale.Pt]: 'Número de turnos de trabalho do auxiliar principal',
        [Locale.Ge]: `Number of work shifts of the main assistant`,
    },
    endDayNextDay: {
        [Locale.Ru]: `Дата окончания в завтрашнем дне`,
        [Locale.Am]: `Ավարտի ամսաթիվը վաղվա օրում`,
        [Locale.En]: `End date in tomorrow`,
        [Locale.Pt]: 'Data de término amanhã',
        [Locale.Ge]: `End date in tomorrow`,
    },
    hasReservationOnDay: {
        [Locale.Ru]: `На этот день есть брони в расписании`,
        [Locale.Am]: `Այս օրվա համար ժամանակացույցում կան ամրագրումներ`,
        [Locale.En]: `There are reservations on the schedule for this day`,
        [Locale.Pt]: 'Há reservas na agenda para este dia',
        [Locale.Ge]: `There are reservations on the schedule for this day`,
    },
    hasReservationOnSchedule: {
        [Locale.Ru]: `На удаляемое расписание есть активные брони в расписании`,
        [Locale.Am]: `Ջնջվող ժամանակացույցի համար կան ակտիվ ամրագրումներ`,
        [Locale.En]: `There are active reservations in the schedule for the deleted schedule`,
        [Locale.Pt]: 'Existem reservas ativas na agenda para a agenda excluída',
        [Locale.Ge]: `There are active reservations in the schedule for the deleted schedule`,
    },
    assistantMorningShift: {
        [Locale.Ru]: `Ассистенты (утренняя смена)`,
        [Locale.Am]: `Օգնականներ (առավոտյան հերթափոխ)`,
        [Locale.En]: `Assistants (morning shift)`,
        [Locale.Pt]: 'Assistentes (turno matutino)',
        [Locale.Ge]: `Assistants (morning shift)`,
    },
    assistantEveninghift: {
        [Locale.Ru]: `Ассистенты (Вечерняя смена)`,
        [Locale.Am]: `Օգնականներ (երեկոյան հերթափոխ)`,
        [Locale.En]: `Assistants (evening shift)`,
        [Locale.Pt]: 'Assistentes (turno noturno)',
        [Locale.Ge]: `Assistants (evening shift)`,
    },
    morningShift: {
        [Locale.Ru]: `Утренняя смена`,
        [Locale.Am]: `Առավոտյան հերթափոխ`,
        [Locale.En]: `Morning shift`,
        [Locale.Pt]: 'Turno da manhã',
        [Locale.Ge]: `Morning shift`,
    },
    eveningShift: {
        [Locale.Ru]: `Вечерняя смена`,
        [Locale.Am]: `Երեկոյան հերթափոխ`,
        [Locale.En]: `Evening shift`,
        [Locale.Pt]: 'Turno noturno',
        [Locale.Ge]: `Evening shift`,
    },
    errorOnSaveData: {
        [Locale.Ru]: `Ошибка сохранения данных`,
        [Locale.Am]: `Տվյալների պահպանման սխալ`,
        [Locale.En]: `Error saving data`,
        [Locale.Pt]: 'Erro ao salvar dados',
        [Locale.Ge]: `Error saving data`,
    },
    openEntry: {
        [Locale.Ru]: `Открыть запись`,
        [Locale.Am]: `Բացել գրառումը`,
        [Locale.En]: `Open entry`,
        [Locale.Pt]: 'Entrada aberta',
        [Locale.Ge]: `Open entry`,
    },
    activeEpisode: {
        [Locale.Ru]: `активный эпизод`,
        [Locale.Am]: `ակտիվ էպիզոդ`,
        [Locale.En]: `active episode`,
        [Locale.Pt]: 'episódio ativo',
        [Locale.Ge]: `active episode`,
    },
    activeEpisodeTwo: {
        [Locale.Ru]: `активных эпизода`,
        [Locale.Am]: `ակտիվ էպիզոդ`,
        [Locale.En]: `active episodes`,
        [Locale.Pt]: 'episódios ativos',
        [Locale.Ge]: `active episodes`,
    },
    activeEpisodes: {
        [Locale.Ru]: `активных эпизодов`,
        [Locale.Am]: `ակտիվ էպիզոդ`,
        [Locale.En]: `active episodes`,
        [Locale.Pt]: 'episódios ativos',
        [Locale.Ge]: `active episodes`,
    },
    activeTasks: {
        [Locale.Ru]: `Активные задания`,
        [Locale.Am]: `Ակտիվ առաջադրանքներ`,
        [Locale.En]: `Active tasks`,
        [Locale.Pt]: 'Tarefas ativas',
        [Locale.Ge]: `Active tasks`,
    },
    completedOrOverdue: {
        [Locale.Ru]: `Выполнено или просрочено:`,
        [Locale.Am]: `Կատարված է կամ ժամկետանց՝`,
        [Locale.En]: `Completed or overdue:`,
        [Locale.Pt]: 'Concluído ou vencido:',
        [Locale.Ge]: `Completed or overdue:`,
    },
    activeRecommendations: {
        [Locale.Ru]: `Активные рекомендации`,
        [Locale.Am]: `Ակտիվ հանձնարարականներ`,
        [Locale.En]: `Active recommendations`,
        [Locale.Pt]: 'Recomendações ativas',
        [Locale.Ge]: `Active recommendations`,
    },
    canceledOrExpired: {
        [Locale.Ru]: 'Отменено или истекло',
        [Locale.Am]: 'Չեղարկված է կամ ժամկետն անցել է',
        [Locale.En]: 'Canceled or expired',
        [Locale.Pt]: 'Cancelado ou expirado',
        [Locale.Ge]: 'Canceled or expired',
    },
    expiredRecommendations: {
        [Locale.Ru]: 'Истекшее',
        [Locale.Am]: 'Ժամկետանց',
        [Locale.En]: 'Expired',
        [Locale.Pt]: 'Expirado',
        [Locale.Ge]: 'Expired',
    },
    activeMedications: {
        [Locale.Ru]: `Принимается в настоящее время`,
        [Locale.Am]: `Ընդունվում է ներկայումս`,
        [Locale.En]: `Currently taking`,
        [Locale.Pt]: 'Tomando atualmente',
        [Locale.Ge]: `Currently taking`,
    },
    plannedOnThisVisit: {
        [Locale.Ru]: `Запланировано на этом приеме`,
        [Locale.Am]: `Պլանավորված է այս ընդունելության ժամանակ`,
        [Locale.En]: `Planned on this visit`,
        [Locale.Pt]: 'Planejado nesta visita',
        [Locale.Ge]: `Planned on this visit`,
    },
    assignedOnThisVisit: {
        [Locale.Ru]: `Назначено на этом приёме`,
        [Locale.Am]: `Նշանակված է այս ընդունելության ժամանակ`,
        [Locale.En]: `Assigned on this visit`,
        [Locale.Pt]: 'Atribuído nesta visita',
        [Locale.Ge]: `Assigned on this visit`,
    },
    activeSubscription: {
        [Locale.Ru]: `активная подписка`,
        [Locale.Am]: `ակտիվ բաժանորդագրություն`,
        [Locale.En]: `active subscription`,
        [Locale.Pt]: 'assinatura ativa',
        [Locale.Ge]: `active subscription`,
    },
    activeSubscriptions: {
        [Locale.Ru]: `активных подписки`,
        [Locale.Am]: `ակտիվ բաժանորդագրություն`,
        [Locale.En]: `active subscriptions`,
        [Locale.Pt]: 'assinaturas ativas',
        [Locale.Ge]: `active subscriptions`,
    },
    activeSubscriptionsMany: {
        [Locale.Ru]: `активных подписок`,
        [Locale.Am]: `ակտիվ բաժանորդագրություն`,
        [Locale.En]: `active subscriptions`,
        [Locale.Pt]: 'assinaturas ativas',
        [Locale.Ge]: `active subscriptions`,
    },
    archiveSubscription: {
        [Locale.Ru]: `архивная подписка`,
        [Locale.Am]: `արխիվային բաժանորդագրություն`,
        [Locale.En]: `Archive subscription`,
        [Locale.Pt]: 'Assinatura de arquivo',
        [Locale.Ge]: `Archive subscription`,
    },
    archiveSubscriptionTwo: {
        [Locale.Ru]: `архивных подписки`,
        [Locale.Am]: `արխիվային բաժանորդագրություն`,
        [Locale.En]: `Archive subscriptions`,
        [Locale.Pt]: 'Arquivar assinaturas',
        [Locale.Ge]: `Archive subscriptions`,
    },
    archiveSubscriptions: {
        [Locale.Ru]: `архивных подписок`,
        [Locale.Am]: `արխիվային բաժանորդագրություն`,
        [Locale.En]: `archive subscriptions`,
        [Locale.Pt]: 'arquivar assinaturas',
        [Locale.Ge]: `archive subscriptions`,
    },
    endingSubscription: {
        [Locale.Ru]: `заканчивающаяся подписка`,
        [Locale.Am]: `ավարտվող բաժանորդագրություն`,
        [Locale.En]: `ending subscription`,
        [Locale.Pt]: 'encerrando assinatura',
        [Locale.Ge]: `ending subscription`,
    },
    endingSubscriptions: {
        [Locale.Ru]: `заканчивающихся подписки`,
        [Locale.Am]: `ավարտվող բաժանորդագրություն`,
        [Locale.En]: `ending subscriptions`,
        [Locale.Pt]: 'encerrando assinaturas',
        [Locale.Ge]: `ending subscriptions`,
    },
    endingSubscriptionMany: {
        [Locale.Ru]: `заканчивающихся подписок`,
        [Locale.Am]: `ավարտվող բաժանորդագրություն`,
        [Locale.En]: `ending subscriptions`,
        [Locale.Pt]: 'encerrando assinaturas',
        [Locale.Ge]: `ending subscriptions`,
    },
    createUser: {
        [Locale.Ru]: `Создать пользователя`,
        [Locale.Am]: `Ստեղծել օգտատեր`,
        [Locale.En]: `Create user`,
        [Locale.Pt]: 'Criar usuário',
        [Locale.Ge]: `Create user`,
    },
    uploadCSV: {
        [Locale.Ru]: `Загрузить CSV`,
        [Locale.Am]: `Վերբեռնել CSV`,
        [Locale.En]: `Upload CSV`,
        [Locale.Pt]: 'Carregar CSV',
        [Locale.Ge]: `Upload CSV`,
    },
    uploadToExcel: {
        [Locale.Ru]: 'Выгрузить в Excel',
        [Locale.Am]: 'Արտահանել Excel',
        [Locale.En]: 'Upload to Excel',
        [Locale.Pt]: 'Carregar para Excel',
        [Locale.Ge]: 'Upload to Excel',
    },
    priceSettings: {
        [Locale.Ru]: `Настройки цен`,
        [Locale.Am]: `Գների կարգավորումներ`,
        [Locale.En]: `Price settings`,
        [Locale.Pt]: 'Configurações de preço',
        [Locale.Ge]: `Price settings`,
    },
    notificationTemplates: {
        [Locale.Ru]: `Шаблоны уведомления`,
        [Locale.Am]: `Ծանուցումների ձևանմուշներ`,
        [Locale.En]: `Notification templates`,
        [Locale.Pt]: 'Modelos de notificação',
        [Locale.Ge]: `Notification templates`,
    },
    pushTitle: {
        [Locale.Ru]: `Заголовок push-уведомления`,
        [Locale.Am]: `Push ծանուցման վերնագիր`,
        [Locale.En]: `Push notification title`,
        [Locale.Pt]: 'Título da notificação push',
        [Locale.Ge]: `Push შეტყობინების სათაური`,
    },
    signFileWithECP: {
        [Locale.Ru]: `Подпись файла с помощью ЭЦП`,
        [Locale.Am]: `Ֆայլի ստորագրում էլեկտրոնային ստորագրությամբ`,
        [Locale.En]: `Signing a file using a digital signature`,
        [Locale.Pt]: 'Assinando um arquivo usando uma assinatura digital',
        [Locale.Ge]: `Signing a file using a digital signature`,
    },
    selectCertText: {
        [Locale.Ru]: `Выберите сертификат для подписи`,
        [Locale.Am]: `Ընտրեք սերտիֆիկատը ստորագրելու համար`,
        [Locale.En]: `Select a certificate to sign`,
        [Locale.Pt]: 'Selecione um certificado para assinar',
        [Locale.Ge]: `Select a certificate to sign`,
    },
    signWithECP: {
        [Locale.Ru]: `Подписать с помощью ЭЦП`,
        [Locale.Am]: `Ստորագրել էլեկտրոնային ստորագրությամբ`,
        [Locale.En]: `Sign with digital signature`,
        [Locale.Pt]: 'Assinar com assinatura digital',
        [Locale.Ge]: `Sign with digital signature`,
    },
    rsChanges: {
        [Locale.Ru]: `Изменения оказанных услуг`,
        [Locale.Am]: `Մատուցված ծառայությունների փոփոխություններ`,
        [Locale.En]: `Changes in services rendered`,
        [Locale.Pt]: 'Mudanças nos serviços prestados',
        [Locale.Ge]: `Changes in services rendered`,
    },
    cReport: {
        [Locale.Ru]: `Отчеты 1С`,
        [Locale.Am]: `1C հաշվետվություններ`,
        [Locale.En]: `1C reports`,
        [Locale.Pt]: 'Relatórios 1C',
        [Locale.Ge]: `1C reports`,
    },
    attacmetDublication: {
        [Locale.Ru]: `Дубли откреплений/прикреплений`,
        [Locale.Am]: `Կցումների/անջատումների կրկնօրինակներ`,
        [Locale.En]: `Duplicate detachments/attachments`,
        [Locale.Pt]: 'Desapegos/anexos duplicados',
        [Locale.Ge]: `Duplicate detachments/attachments`,
    },
    noLegalEntity: {
        [Locale.Ru]: `Не найдено Юр Лицо`,
        [Locale.Am]: `Իրավաբանական անձ չի գտնվել`,
        [Locale.En]: `No Legal Entity Found`,
        [Locale.Pt]: 'Nenhuma entidade legal encontrada',
        [Locale.Ge]: `No Legal Entity Found`,
    },
    patientDuplicates: {
        [Locale.Ru]: `Дубли пациентов`,
        [Locale.Am]: `Պացիենտների կրկնօրինակներ`,
        [Locale.En]: `Patient duplicates`,
        [Locale.Pt]: 'Duplicatas de pacientes',
        [Locale.Ge]: `Patient duplicates`,
    },
    patientNotFounded: {
        [Locale.Ru]: `Не нашел пациента`,
        [Locale.Am]: `Պացիենտը չի գտնվել`,
        [Locale.En]: `Didn't find a patient`,
        [Locale.Pt]: `Não foi encontrado qualquer doente.`,
        [Locale.Ge]: `Didn't find a patient`,
    },
    cannotChangeDuration: {
        [Locale.Ru]: `Невозможно изменить длительность`,
        [Locale.Am]: `Անհնար է փոփոխել տևողությունը`,
        [Locale.En]: `Cannot change duration`,
        [Locale.Pt]: 'Não é possível alterar a duração',
        [Locale.Ge]: `Cannot change duration`,
    },
    subscriptionNotFound: {
        [Locale.Ru]: `Не найдена подписка`,
        [Locale.Am]: `Բաժանորդագրությունը չի գտնվել`,
        [Locale.En]: `Subscription not found`,
        [Locale.Pt]: 'Assinatura não encontrada',
        [Locale.Ge]: `Subscription not found`,
    },
    startDateMoreThanEnd: {
        [Locale.Ru]: `Дата начала больше даты окончания`,
        [Locale.Am]: `Սկզբի ամսաթիվը մեծ է ավարտի ամսաթվից`,
        [Locale.En]: `Start date is greater than end date`,
        [Locale.Pt]: 'A data de início é posterior à data de término',
        [Locale.Ge]: `Start date is greater than end date`,
    },
    pageNotFound: {
        [Locale.Ru]: `Страница не обнаружена`,
        [Locale.Am]: `Էջը չի գտնվել`,
        [Locale.En]: `Page not found`,
        [Locale.Pt]: `Página não encontrada`,
        [Locale.Ge]: `Page not found`,
    },
    page: {
        [Locale.Ru]: `Страница`,
        [Locale.Am]: `Էջ`,
        [Locale.En]: `Page`,
        [Locale.Pt]: `Página`,
        [Locale.Ge]: `Page`,
    },
    userWithEmail: {
        [Locale.Ru]: `Пользователь с электронной почтой`,
        [Locale.Am]: `Օգտատերն այս էլ. հասցեով`,
        [Locale.En]: `User with email`,
        [Locale.Pt]: 'Usuário com e-mail',
        [Locale.Ge]: `User with email`,
    },
    notFound: {
        [Locale.Ru]: `не найден`,
        [Locale.Am]: `չի գտնվել`,
        [Locale.En]: `not found`,
        [Locale.Pt]: 'não encontrado',
        [Locale.Ge]: `not found`,
    },
    makeSureEmailText: {
        [Locale.Ru]: `Убедитесь, что выбрали правильную электронную почту`,
        [Locale.Am]: `Համոզվեք, որ ընտրել եք ճիշտ էլ. հասցեն`,
        [Locale.En]: `Make sure you have selected the correct email.`,
        [Locale.Pt]: 'Certifique-se de ter selecionado o e-mail correto.',
        [Locale.Ge]: `Make sure you have selected the correct email.`,
    },
    tryAgain: {
        [Locale.Ru]: `Попробовать еще раз`,
        [Locale.Am]: `Փորձել կրկին`,
        [Locale.En]: `Try again`,
        [Locale.Pt]: `Tentar novamente`,
        [Locale.Ge]: `Try again`,
    },
    scale: {
        [Locale.Ru]: `Масштаб`,
        [Locale.Am]: `Մասշտաբ`,
        [Locale.En]: `Scale`,
        [Locale.Pt]: 'Escala',
        [Locale.Ge]: `Scale`,
    },
    uploadingCSVFile: {
        [Locale.Ru]: `Загрузка CSV файла`,
        [Locale.Am]: `CSV ֆայլի վերբեռնում`,
        [Locale.En]: `Uploading CSV file`,
        [Locale.Pt]: 'Carregando arquivo CSV',
        [Locale.Ge]: `Uploading CSV file`,
    },
    uploadingCSV: {
        [Locale.Ru]: `Загрузка CSV`,
        [Locale.Am]: `CSV-ի վերբեռնում`,
        [Locale.En]: `Uploading CSV`,
        [Locale.Pt]: 'Fazendo upload de CSV',
        [Locale.Ge]: `Uploading CSV`,
    },
    uploadNewPhoto: {
        [Locale.Ru]: `Загрузить новую фотографию`,
        [Locale.Am]: `Վերբեռնել նոր լուսանկար`,
        [Locale.En]: `Upload a new photo`,
        [Locale.Pt]: 'Carregar uma nova foto',
        [Locale.Ge]: `Upload a new photo`,
    },
    addPhoto: {
        [Locale.Ru]: `Добавить фотографию`,
        [Locale.Am]: `Ավելացնել լուսանկար`,
        [Locale.En]: `Add a photo`,
        [Locale.Pt]: 'Adicione uma foto',
        [Locale.Ge]: `Add a photo`,
    },
    editPhoto: {
        [Locale.Ru]: `Редактировать фотографию`,
        [Locale.Am]: `Խմբագրել լուսանկարը`,
        [Locale.En]: `Edit photo`,
        [Locale.Pt]: 'Editar foto',
        [Locale.Ge]: `Edit photo`,
    },
    youRegisteredInChat: {
        [Locale.Ru]: `Вы зарегистрированы в чате`,
        [Locale.Am]: `Դուք գրանցված եք չաթում`,
        [Locale.En]: `You are registered in the chat`,
        [Locale.Pt]: 'Você está registrado no chat',
        [Locale.Ge]: `You are registered in the chat`,
    },
    userRegisteredInChat: {
        [Locale.Ru]: `Пользователь зарегистрирован в чате`,
        [Locale.Am]: `Օգտատերը գրանցված է չաթում`,
        [Locale.En]: `The user is registered in the chat`,
        [Locale.Pt]: 'O usuário está registrado no chat',
        [Locale.Ge]: `The user is registered in the chat`,
    },
    botBanned: {
        [Locale.Ru]: `Бот забанен`,
        [Locale.Am]: `Բոտն արգելափակված է`,
        [Locale.En]: `Bot banned`,
        [Locale.Pt]: 'Bot banido',
        [Locale.Ge]: `Bot banned`,
    },
    chatRegistrationStatusUnknown: {
        [Locale.Ru]: `Статус регистрации в чате неизвестен`,
        [Locale.Am]: `Չաթում գրանցման կարգավիճակն անհայտ է`,
        [Locale.En]: `Chat registration status is unknown`,
        [Locale.Pt]: 'O status de registro no chat é desconhecido',
        [Locale.Ge]: `Chat registration status is unknown`,
    },
    errorWhileLoadingService: {
        [Locale.Ru]: `Возникла ошибка при загрузке услуг`,
        [Locale.Am]: `Ծառայությունները բեռնելիս առաջացել է սխալ`,
        [Locale.En]: `An error occurred while loading services`,
        [Locale.Pt]: 'Ocorreu um erro ao carregar serviços',
        [Locale.Ge]: `An error occurred while loading services`,
    },
    timezone: {
        [Locale.Ru]: `Таймзона`,
        [Locale.Am]: `Ժամային գոտի`,
        [Locale.En]: `Timezone`,
        [Locale.Pt]: 'Fuso horário',
        [Locale.Ge]: `Timezone`,
    },
    setting: {
        [Locale.Ru]: `Настройка`,
        [Locale.Am]: `Կարգավորում`,
        [Locale.En]: `Setting`,
        [Locale.Pt]: 'Contexto',
        [Locale.Ge]: `Setting`,
    },
    accountInitializingError: {
        [Locale.Ru]: `Ошибка инициализации сип аккаунта`,
        [Locale.Am]: `SIP հաշվի սկզբնավորման սխալ`,
        [Locale.En]: `Error initializing sip account`,
        [Locale.Pt]: 'Erro ao inicializar conta SIP',
        [Locale.Ge]: `Error initializing sip account`,
    },
    copyToClipboard: {
        [Locale.Ru]: `Скопировать в буфер обмена`,
        [Locale.Am]: `Պատճենել սեղմատախտակին`,
        [Locale.En]: `Copy to clipboard`,
        [Locale.Pt]: 'Copiar para a área de transferência',
        [Locale.Ge]: `Copy to clipboard`,
    },
    copied: {
        [Locale.Ru]: `Скопировано!`,
        [Locale.Am]: `Պատճենվել է։`,
        [Locale.En]: `Copied!`,
        [Locale.Pt]: 'Copiado!',
        [Locale.Ge]: `Copied!`,
    },
    reportByPayments: {
        [Locale.Ru]: 'Отчет по оплатам',
        [Locale.Am]: 'Հաշվետվություն ըստ վճարումների',
        [Locale.En]: 'Report by payments',
        [Locale.Pt]: 'Relatório por pagamentos',
        [Locale.Ge]: 'Report by payments',
    },
    somethingWentWrong: {
        [Locale.Ru]: `Что-то пошло не так`,
        [Locale.Am]: `Ինչ-որ բան այն չէ`,
        [Locale.En]: `Something went wrong`,
        [Locale.Pt]: 'Algo deu errado',
        [Locale.Ge]: `Something went wrong`,
    },
    tgLinksText: {
        [Locale.Ru]: `Ссылки на группы в Telegram`,
        [Locale.Am]: `Telegram-ի խմբերի հղումներ`,
        [Locale.En]: `Links to groups in Telegram`,
        [Locale.Pt]: 'Links para grupos no Telegram',
        [Locale.Ge]: `Links to groups in Telegram`,
    },
    available: {
        [Locale.Ru]: `Доступно`,
        [Locale.Am]: `Հասանելի է`,
        [Locale.En]: `Available`,
        [Locale.Pt]: 'Disponível',
        [Locale.Ge]: `Available`,
    },
    subscriptionPrices: {
        [Locale.Ru]: `Цены на подписку`,
        [Locale.Am]: `Բաժանորդագրության գներ`,
        [Locale.En]: `Subscription prices`,
        [Locale.Pt]: 'Preços de assinatura',
        [Locale.Ge]: `Subscription prices`,
    },
    userHasActiveSub: {
        [Locale.Ru]: 'У пользователя остались активные подписки',
        [Locale.Am]: 'Օգտատերն ունի ակտիվ բաժանորդագրություններ',
        [Locale.En]: 'User has active subscriptions',
        [Locale.Pt]: 'O usuário tem assinaturas ativas',
        [Locale.Ge]: 'User has active subscriptions',
    },
    // NAME: {
    //     [Locale.Ru]: ``,
    //     [Locale.Am]: ``,
    //     [Locale.En]: ``,
    // [Locale.Pt]: '',
    //     [Locale.Ge]: ``,
    // },
    email: {
        [Locale.Ru]: 'E-mail',
        [Locale.Am]: 'E-mail',
        [Locale.En]: 'E-mail',
        [Locale.Pt]: 'E-mail',
        [Locale.Ge]: 'E-mail',
    },
    workPlace: {
        [Locale.Ru]: 'Рабочее место',
        [Locale.Am]: 'Աշխատատեղ',
        [Locale.En]: 'Workplace',
        [Locale.Pt]: 'Local de trabalho',
        [Locale.Ge]: 'Workplace',
    },
    featureAvailableForAll: {
        [Locale.Ru]: 'Доступно для всех пользователей',
        [Locale.Am]: 'Հասանելի է բոլոր օգտատերերին',
        [Locale.En]: 'Available for all users',
        [Locale.Pt]: 'Disponível para todos os usuários',
        [Locale.Ge]: 'Available for all users',
    },
    featureAvailableForAllConfirm: {
        [Locale.Ru]: 'Вы действительно хотите включить функционал $featureTitle для всех пользователей?',
        [Locale.Am]: 'Իսկապե՞ս ուզում եք միացնել $featureTitle ֆունկցիոնալը բոլոր օգտատերերի համար',
        [Locale.En]: 'Do you really want to enable $featureTitle for all users?',
        [Locale.Pt]: 'Deseja realmente ativar $featureTitle para todos os usuários?',
        [Locale.Ge]: 'Do you really want to enable $featureTitle for all users?',
    },
    featureEnableDateForAll: {
        [Locale.Ru]: 'Дата когда должно включится для всех',
        [Locale.Am]: 'Ամսաթիվ, երբ պետք է միանա բոլորի համար',
        [Locale.En]: 'Date when it should be enabled for everyone',
        [Locale.Pt]: 'Data em que deve ser ativado para todos',
        [Locale.Ge]: 'Date when it should be enabled for everyone',
    },
    featureAvailableForUsers: {
        [Locale.Ru]: 'Доступно для пользователей',
        [Locale.Am]: 'Հասանելի է օգտատերերին',
        [Locale.En]: 'Available for users',
        [Locale.Pt]: 'Disponível para usuários',
        [Locale.Ge]: 'Available for users',
    },
    featureAvailableForOrganizations: {
        [Locale.Ru]: 'Доступно для организаций',
        [Locale.Am]: 'Հասանելի է կազմակերպությունների համար',
        [Locale.En]: 'Available for organizations',
        [Locale.Pt]: 'Disponível para organizações',
        [Locale.Ge]: 'Available for organizations',
    },
    chatRegistrationFailed: {
        [Locale.Ru]: 'Неудалось зарегистрироваться в чате. Обратитесь в тех поддержку',
        [Locale.Am]: 'Չհաջողվեց գրանցվել չաթում։ Դիմեք տեխնիկական աջակցությանը',
        [Locale.En]: 'Failed to register in chat. Contact support',
        [Locale.Pt]: 'Falha ao registrar no chat. Entre em contato com o suporte',
        [Locale.Ge]: 'Failed to register in chat. Contact support',
    },
};
